import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ArchivedFilter = /*#__PURE__*/function (ArchivedFilter) {
  ArchivedFilter[ArchivedFilter["ARCHIVED_FILTER_NOT_ARCHIVED"] = 0] = "ARCHIVED_FILTER_NOT_ARCHIVED";
  ArchivedFilter[ArchivedFilter["ARCHIVED_FILTER_IS_ARCHIVED"] = 1] = "ARCHIVED_FILTER_IS_ARCHIVED";
  ArchivedFilter[ArchivedFilter["ARCHIVED_FILTER_ANY"] = 2] = "ARCHIVED_FILTER_ANY";
  return ArchivedFilter;
}(ArchivedFilter || {});
var DateRange = /*#__PURE__*/function (DateRange) {
  DateRange[DateRange["DATE_RANGE_INVALID"] = 0] = "DATE_RANGE_INVALID";
  DateRange[DateRange["DATE_RANGE_7DAYS"] = 1] = "DATE_RANGE_7DAYS";
  DateRange[DateRange["DATE_RANGE_30DAYS"] = 2] = "DATE_RANGE_30DAYS";
  DateRange[DateRange["DATE_RANGE_60DAYS"] = 3] = "DATE_RANGE_60DAYS";
  DateRange[DateRange["DATE_RANGE_ALL_TIME"] = 4] = "DATE_RANGE_ALL_TIME";
  return DateRange;
}(DateRange || {});
var LatestSalesActivityOption = /*#__PURE__*/function (LatestSalesActivityOption) {
  LatestSalesActivityOption[LatestSalesActivityOption["LATEST_SALES_ACTIVITY_OPTION_ALL_TIME"] = 0] = "LATEST_SALES_ACTIVITY_OPTION_ALL_TIME";
  LatestSalesActivityOption[LatestSalesActivityOption["LATEST_SALES_ACTIVITY_OPTION_WITHIN_THE_LAST_30_DAYS"] = 1] = "LATEST_SALES_ACTIVITY_OPTION_WITHIN_THE_LAST_30_DAYS";
  LatestSalesActivityOption[LatestSalesActivityOption["LATEST_SALES_ACTIVITY_OPTION_OLDER_THAN_30_DAYS"] = 2] = "LATEST_SALES_ACTIVITY_OPTION_OLDER_THAN_30_DAYS";
  return LatestSalesActivityOption;
}(LatestSalesActivityOption || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["SORT_DIRECTION_INVALID"] = 0] = "SORT_DIRECTION_INVALID";
  SortDirection[SortDirection["SORT_DIRECTION_ASCENDING"] = 1] = "SORT_DIRECTION_ASCENDING";
  SortDirection[SortDirection["SORT_DIRECTION_DESCENDING"] = 2] = "SORT_DIRECTION_DESCENDING";
  return SortDirection;
}(SortDirection || {});
var Status = /*#__PURE__*/function (Status) {
  Status[Status["STATUS_INVALID"] = 0] = "STATUS_INVALID";
  Status[Status["STATUS_UNREAD_ACTIVITY"] = 1] = "STATUS_UNREAD_ACTIVITY";
  Status[Status["STATUS_ACCOUNT_CREATED"] = 2] = "STATUS_ACCOUNT_CREATED";
  Status[Status["STATUS_READY_TO_SELL"] = 3] = "STATUS_READY_TO_SELL";
  Status[Status["STATUS_IN_PROGRESS"] = 4] = "STATUS_IN_PROGRESS";
  Status[Status["STATUS_FOLLOW_UP_NEEDED"] = 5] = "STATUS_FOLLOW_UP_NEEDED";
  Status[Status["STATUS_CLOSED_WON"] = 6] = "STATUS_CLOSED_WON";
  Status[Status["STATUS_CLOSED_LOST"] = 7] = "STATUS_CLOSED_LOST";
  return Status;
}(Status || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccountsCreatedRange = /*#__PURE__*/function (AccountsCreatedRange) {
  AccountsCreatedRange[AccountsCreatedRange["ACCOUNTS_CREATED_RANGE_UNKNOWN"] = 0] = "ACCOUNTS_CREATED_RANGE_UNKNOWN";
  AccountsCreatedRange[AccountsCreatedRange["ACCOUNTS_CREATED_RANGE_1"] = 1] = "ACCOUNTS_CREATED_RANGE_1";
  AccountsCreatedRange[AccountsCreatedRange["ACCOUNTS_CREATED_RANGE_1_2"] = 2] = "ACCOUNTS_CREATED_RANGE_1_2";
  AccountsCreatedRange[AccountsCreatedRange["ACCOUNTS_CREATED_RANGE_3_49"] = 3] = "ACCOUNTS_CREATED_RANGE_3_49";
  AccountsCreatedRange[AccountsCreatedRange["ACCOUNTS_CREATED_RANGE_50_99"] = 4] = "ACCOUNTS_CREATED_RANGE_50_99";
  AccountsCreatedRange[AccountsCreatedRange["ACCOUNTS_CREATED_RANGE_100_249"] = 5] = "ACCOUNTS_CREATED_RANGE_100_249";
  AccountsCreatedRange[AccountsCreatedRange["ACCOUNTS_CREATED_RANGE_250_499"] = 6] = "ACCOUNTS_CREATED_RANGE_250_499";
  AccountsCreatedRange[AccountsCreatedRange["ACCOUNTS_CREATED_RANGE_500PLUS"] = 7] = "ACCOUNTS_CREATED_RANGE_500PLUS";
  return AccountsCreatedRange;
}(AccountsCreatedRange || {});
var BilledClientsRange = /*#__PURE__*/function (BilledClientsRange) {
  BilledClientsRange[BilledClientsRange["BILLED_CLIENTS_RANGE_UNKNOWN"] = 0] = "BILLED_CLIENTS_RANGE_UNKNOWN";
  BilledClientsRange[BilledClientsRange["BILLED_CLIENTS_RANGE_0"] = 1] = "BILLED_CLIENTS_RANGE_0";
  BilledClientsRange[BilledClientsRange["BILLED_CLIENTS_RANGE_1_4"] = 2] = "BILLED_CLIENTS_RANGE_1_4";
  BilledClientsRange[BilledClientsRange["BILLED_CLIENTS_RANGE_5_19"] = 3] = "BILLED_CLIENTS_RANGE_5_19";
  BilledClientsRange[BilledClientsRange["BILLED_CLIENTS_RANGE_20_99"] = 4] = "BILLED_CLIENTS_RANGE_20_99";
  BilledClientsRange[BilledClientsRange["BILLED_CLIENTS_RANGE_100_249"] = 5] = "BILLED_CLIENTS_RANGE_100_249";
  BilledClientsRange[BilledClientsRange["BILLED_CLIENTS_RANGE_250_999"] = 6] = "BILLED_CLIENTS_RANGE_250_999";
  BilledClientsRange[BilledClientsRange["BILLED_CLIENTS_RANGE_1000_4999"] = 7] = "BILLED_CLIENTS_RANGE_1000_4999";
  BilledClientsRange[BilledClientsRange["BILLED_CLIENTS_RANGE_5000PLUS"] = 8] = "BILLED_CLIENTS_RANGE_5000PLUS";
  return BilledClientsRange;
}(BilledClientsRange || {});
var BooleanFilter = /*#__PURE__*/function (BooleanFilter) {
  BooleanFilter[BooleanFilter["BOOLEAN_FILTER_UNSET"] = 0] = "BOOLEAN_FILTER_UNSET";
  BooleanFilter[BooleanFilter["BOOLEAN_FILTER_FALSE"] = 1] = "BOOLEAN_FILTER_FALSE";
  BooleanFilter[BooleanFilter["BOOLEAN_FILTER_TRUE"] = 2] = "BOOLEAN_FILTER_TRUE";
  return BooleanFilter;
}(BooleanFilter || {});
var ContractStatus = /*#__PURE__*/function (ContractStatus) {
  ContractStatus[ContractStatus["CONTRACT_STATUS_UNKNOWN"] = 0] = "CONTRACT_STATUS_UNKNOWN";
  ContractStatus[ContractStatus["CONTRACT_STATUS_ACTIVE"] = 1] = "CONTRACT_STATUS_ACTIVE";
  ContractStatus[ContractStatus["CONTRACT_STATUS_CANCELLED"] = 2] = "CONTRACT_STATUS_CANCELLED";
  ContractStatus[ContractStatus["CONTRACT_STATUS_DRAFT"] = 3] = "CONTRACT_STATUS_DRAFT";
  ContractStatus[ContractStatus["CONTRACT_STATUS_HOLD"] = 4] = "CONTRACT_STATUS_HOLD";
  ContractStatus[ContractStatus["CONTRACT_STATUS_SUSPENDED"] = 5] = "CONTRACT_STATUS_SUSPENDED";
  return ContractStatus;
}(ContractStatus || {});
var EmailType = /*#__PURE__*/function (EmailType) {
  EmailType[EmailType["EMAIL_TYPE_INVALID"] = 0] = "EMAIL_TYPE_INVALID";
  EmailType[EmailType["EMAIL_TYPE_UNKNOWN"] = 1] = "EMAIL_TYPE_UNKNOWN";
  EmailType[EmailType["EMAIL_TYPE_GENERIC_PROVIDER"] = 2] = "EMAIL_TYPE_GENERIC_PROVIDER";
  EmailType[EmailType["EMAIL_TYPE_BRANDED_TO_THEIR_DOMAIN"] = 3] = "EMAIL_TYPE_BRANDED_TO_THEIR_DOMAIN";
  return EmailType;
}(EmailType || {});
var HasPidFilter = /*#__PURE__*/function (HasPidFilter) {
  HasPidFilter[HasPidFilter["HAS_PID_FILTER_UNKNOWN"] = 0] = "HAS_PID_FILTER_UNKNOWN";
  HasPidFilter[HasPidFilter["HAS_PID_FILTER_NO_PID"] = 1] = "HAS_PID_FILTER_NO_PID";
  HasPidFilter[HasPidFilter["HAS_PID_FILTER_WITH_PID"] = 2] = "HAS_PID_FILTER_WITH_PID";
  return HasPidFilter;
}(HasPidFilter || {});
var PaidProductsRange = /*#__PURE__*/function (PaidProductsRange) {
  PaidProductsRange[PaidProductsRange["PAID_PRODUCTS_RANGE_UNKNOWN"] = 0] = "PAID_PRODUCTS_RANGE_UNKNOWN";
  PaidProductsRange[PaidProductsRange["PAID_PRODUCTS_RANGE_1_2"] = 1] = "PAID_PRODUCTS_RANGE_1_2";
  PaidProductsRange[PaidProductsRange["PAID_PRODUCTS_RANGE_3"] = 2] = "PAID_PRODUCTS_RANGE_3";
  PaidProductsRange[PaidProductsRange["PAID_PRODUCTS_RANGE_4_5"] = 3] = "PAID_PRODUCTS_RANGE_4_5";
  PaidProductsRange[PaidProductsRange["PAID_PRODUCTS_RANGE_6_10"] = 4] = "PAID_PRODUCTS_RANGE_6_10";
  PaidProductsRange[PaidProductsRange["PAID_PRODUCTS_RANGE_11_20"] = 5] = "PAID_PRODUCTS_RANGE_11_20";
  PaidProductsRange[PaidProductsRange["PAID_PRODUCTS_RANGE_21_50"] = 6] = "PAID_PRODUCTS_RANGE_21_50";
  PaidProductsRange[PaidProductsRange["PAID_PRODUCTS_RANGE_51_100"] = 7] = "PAID_PRODUCTS_RANGE_51_100";
  PaidProductsRange[PaidProductsRange["PAID_PRODUCTS_RANGE_100PLUS"] = 8] = "PAID_PRODUCTS_RANGE_100PLUS";
  return PaidProductsRange;
}(PaidProductsRange || {});
var SubscriptionChangeFilter = /*#__PURE__*/function (SubscriptionChangeFilter) {
  SubscriptionChangeFilter[SubscriptionChangeFilter["SUBSCRIPTION_CHANGE_FILTER_UNSET"] = 0] = "SUBSCRIPTION_CHANGE_FILTER_UNSET";
  SubscriptionChangeFilter[SubscriptionChangeFilter["SUBSCRIPTION_CHANGE_FILTER_UPGRADED"] = 1] = "SUBSCRIPTION_CHANGE_FILTER_UPGRADED";
  SubscriptionChangeFilter[SubscriptionChangeFilter["SUBSCRIPTION_CHANGE_FILTER_DOWNGRADED"] = 2] = "SUBSCRIPTION_CHANGE_FILTER_DOWNGRADED";
  return SubscriptionChangeFilter;
}(SubscriptionChangeFilter || {});
var SubscriptionTier = /*#__PURE__*/function (SubscriptionTier) {
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_BASIC"] = 0] = "SUBSCRIPTION_TIER_BASIC";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_PROFESSIONAL"] = 1] = "SUBSCRIPTION_TIER_PROFESSIONAL";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_ENTERPRISE"] = 2] = "SUBSCRIPTION_TIER_ENTERPRISE";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_LITE"] = 3] = "SUBSCRIPTION_TIER_LITE";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_PREMIUM"] = 4] = "SUBSCRIPTION_TIER_PREMIUM";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_ELITE"] = 5] = "SUBSCRIPTION_TIER_ELITE";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_FREE"] = 6] = "SUBSCRIPTION_TIER_FREE";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_STARTER"] = 7] = "SUBSCRIPTION_TIER_STARTER";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_BASIC_PLUS"] = 8] = "SUBSCRIPTION_TIER_BASIC_PLUS";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_PROFESSIONAL_PLUS"] = 9] = "SUBSCRIPTION_TIER_PROFESSIONAL_PLUS";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_ENTERPRISE_PLUS"] = 10] = "SUBSCRIPTION_TIER_ENTERPRISE_PLUS";
  SubscriptionTier[SubscriptionTier["SUBSCRIPTION_TIER_REPLACED_BY_SUBSCRIPTION_TIERS"] = 11] = "SUBSCRIPTION_TIER_REPLACED_BY_SUBSCRIPTION_TIERS";
  return SubscriptionTier;
}(SubscriptionTier || {});
var WebsiteFilter = /*#__PURE__*/function (WebsiteFilter) {
  WebsiteFilter[WebsiteFilter["WEBSITE_FILTER_UNSET"] = 0] = "WEBSITE_FILTER_UNSET";
  WebsiteFilter[WebsiteFilter["WEBSITE_FILTER_NO_WEBSITE"] = 1] = "WEBSITE_FILTER_NO_WEBSITE";
  WebsiteFilter[WebsiteFilter["WEBSITE_FILTER_HAS_WEBSITE"] = 2] = "WEBSITE_FILTER_HAS_WEBSITE";
  return WebsiteFilter;
}(WebsiteFilter || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var StatusType = /*#__PURE__*/function (StatusType) {
  StatusType[StatusType["STATUS_TYPE_UNKNOWN"] = 0] = "STATUS_TYPE_UNKNOWN";
  StatusType[StatusType["STATUS_TYPE_PENDING"] = 1] = "STATUS_TYPE_PENDING";
  StatusType[StatusType["STATUS_TYPE_APPROVED"] = 2] = "STATUS_TYPE_APPROVED";
  StatusType[StatusType["STATUS_TYPE_REJECTED"] = 3] = "STATUS_TYPE_REJECTED";
  return StatusType;
}(StatusType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CampaignEventType = /*#__PURE__*/function (CampaignEventType) {
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_INVALID"] = 0] = "CAMPAIGN_EVENT_TYPE_INVALID";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_PROCESSED"] = 1] = "CAMPAIGN_EVENT_TYPE_PROCESSED";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_DROPPED"] = 2] = "CAMPAIGN_EVENT_TYPE_DROPPED";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_DELIVERED"] = 3] = "CAMPAIGN_EVENT_TYPE_DELIVERED";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_DEFERRED"] = 4] = "CAMPAIGN_EVENT_TYPE_DEFERRED";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_BOUNCE"] = 5] = "CAMPAIGN_EVENT_TYPE_BOUNCE";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_OPEN"] = 6] = "CAMPAIGN_EVENT_TYPE_OPEN";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_CLICK"] = 7] = "CAMPAIGN_EVENT_TYPE_CLICK";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_SPAM_REPORT"] = 8] = "CAMPAIGN_EVENT_TYPE_SPAM_REPORT";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_UNSUBSCRIBE"] = 9] = "CAMPAIGN_EVENT_TYPE_UNSUBSCRIBE";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_CREATED"] = 10] = "CAMPAIGN_EVENT_TYPE_CREATED";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_NOT_REQUIRED"] = 11] = "CAMPAIGN_EVENT_TYPE_NOT_REQUIRED";
  CampaignEventType[CampaignEventType["CAMPAIGN_EVENT_TYPE_REFRESHED"] = 12] = "CAMPAIGN_EVENT_TYPE_REFRESHED";
  return CampaignEventType;
}(CampaignEventType || {});
var InitiateCampaignHistoryExportRequestOrderBy = /*#__PURE__*/function (InitiateCampaignHistoryExportRequestOrderBy) {
  InitiateCampaignHistoryExportRequestOrderBy[InitiateCampaignHistoryExportRequestOrderBy["INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_ORDER_BY_INVALID"] = 0] = "INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_ORDER_BY_INVALID";
  InitiateCampaignHistoryExportRequestOrderBy[InitiateCampaignHistoryExportRequestOrderBy["INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_ORDER_BY_ASC"] = 1] = "INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_ORDER_BY_ASC";
  InitiateCampaignHistoryExportRequestOrderBy[InitiateCampaignHistoryExportRequestOrderBy["INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_ORDER_BY_DESC"] = 2] = "INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_ORDER_BY_DESC";
  return InitiateCampaignHistoryExportRequestOrderBy;
}(InitiateCampaignHistoryExportRequestOrderBy || {});
var InitiateCampaignHistoryExportRequestSortBy = /*#__PURE__*/function (InitiateCampaignHistoryExportRequestSortBy) {
  InitiateCampaignHistoryExportRequestSortBy[InitiateCampaignHistoryExportRequestSortBy["INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_SORT_BY_INVALID"] = 0] = "INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_SORT_BY_INVALID";
  InitiateCampaignHistoryExportRequestSortBy[InitiateCampaignHistoryExportRequestSortBy["INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_SORT_BY_EVENT_DATE"] = 1] = "INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_SORT_BY_EVENT_DATE";
  return InitiateCampaignHistoryExportRequestSortBy;
}(InitiateCampaignHistoryExportRequestSortBy || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var LeadQualificationType = /*#__PURE__*/function (LeadQualificationType) {
  LeadQualificationType[LeadQualificationType["LEAD_QUALIFICATION_TYPE_UNKNOWN"] = 0] = "LEAD_QUALIFICATION_TYPE_UNKNOWN";
  LeadQualificationType[LeadQualificationType["LEAD_QUALIFICATION_TYPE_QUALIFIED"] = 1] = "LEAD_QUALIFICATION_TYPE_QUALIFIED";
  LeadQualificationType[LeadQualificationType["LEAD_QUALIFICATION_TYPE_UNQUALIFIED"] = 2] = "LEAD_QUALIFICATION_TYPE_UNQUALIFIED";
  return LeadQualificationType;
}(LeadQualificationType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var LeadSource = /*#__PURE__*/function (LeadSource) {
  LeadSource[LeadSource["LEAD_SOURCE_NOT_SET"] = 0] = "LEAD_SOURCE_NOT_SET";
  LeadSource[LeadSource["LEAD_SOURCE_FACEBOOK"] = 1] = "LEAD_SOURCE_FACEBOOK";
  return LeadSource;
}(LeadSource || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CriteriaMatchType = /*#__PURE__*/function (CriteriaMatchType) {
  CriteriaMatchType[CriteriaMatchType["CRITERIA_MATCH_TYPE_UNKNOWN"] = 0] = "CRITERIA_MATCH_TYPE_UNKNOWN";
  CriteriaMatchType[CriteriaMatchType["CRITERIA_MATCH_TYPE_ALL"] = 1] = "CRITERIA_MATCH_TYPE_ALL";
  CriteriaMatchType[CriteriaMatchType["CRITERIA_MATCH_TYPE_ANY"] = 2] = "CRITERIA_MATCH_TYPE_ANY";
  return CriteriaMatchType;
}(CriteriaMatchType || {});
// *********************************

function enumStringToValue$g(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Money {
  static fromProto(proto) {
    let m = new Money();
    m = Object.assign(m, proto);
    if (proto.valueInCents) {
      m.valueInCents = parseInt(proto.valueInCents, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.valueInCents !== 'undefined') {
      toReturn['valueInCents'] = this.valueInCents;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    return toReturn;
  }
}
class MultiSortingOptions {
  static fromProto(proto) {
    let m = new MultiSortingOptions();
    m = Object.assign(m, proto);
    if (proto.sortingOptions) {
      m.sortingOptions = proto.sortingOptions.map(SortingOptions.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sortingOptions !== 'undefined' && this.sortingOptions !== null) {
      toReturn['sortingOptions'] = 'toApiJson' in this.sortingOptions ? this.sortingOptions.toApiJson() : this.sortingOptions;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageIndex) {
      m.pageIndex = parseInt(proto.pageIndex, 10);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageIndex !== 'undefined') {
      toReturn['pageIndex'] = this.pageIndex;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.allRows !== 'undefined') {
      toReturn['allRows'] = this.allRows;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class SortingOptions {
  static fromProto(proto) {
    let m = new SortingOptions();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$g(SortDirection, proto.direction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    return toReturn;
  }
}
function enumStringToValue$f(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AttributeFilters {
  static fromProto(proto) {
    let m = new AttributeFilters();
    m = Object.assign(m, proto);
    if (proto.emailType) {
      m.emailType = enumStringToValue$f(EmailType, proto.emailType);
    }
    if (proto.hasWebsite) {
      m.hasWebsite = enumStringToValue$f(WebsiteFilter, proto.hasWebsite);
    }
    if (proto.isAmountOwing) {
      m.isAmountOwing = enumStringToValue$f(BooleanFilter, proto.isAmountOwing);
    }
    if (proto.subscriptionTier) {
      m.subscriptionTier = proto.subscriptionTier.map(v => enumStringToValue$f(SubscriptionTier, v));
    }
    if (proto.subscriptionChanged) {
      m.subscriptionChanged = proto.subscriptionChanged.map(v => enumStringToValue$f(SubscriptionChangeFilter, v));
    }
    if (proto.contractStatus) {
      m.contractStatus = proto.contractStatus.map(v => enumStringToValue$f(ContractStatus, v));
    }
    if (proto.utmInfo) {
      m.utmInfo = UtmFilters.fromProto(proto.utmInfo);
    }
    if (proto.archivedFilter) {
      m.archivedFilter = enumStringToValue$f(ArchivedFilter, proto.archivedFilter);
    }
    if (proto.billedClients) {
      m.billedClients = proto.billedClients.map(v => enumStringToValue$f(BilledClientsRange, v));
    }
    if (proto.accountsCreated) {
      m.accountsCreated = proto.accountsCreated.map(v => enumStringToValue$f(AccountsCreatedRange, v));
    }
    if (proto.paidProducts) {
      m.paidProducts = proto.paidProducts.map(v => enumStringToValue$f(PaidProductsRange, v));
    }
    if (proto.hasPidFilter) {
      m.hasPidFilter = enumStringToValue$f(HasPidFilter, proto.hasPidFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.qualifications !== 'undefined') {
      toReturn['qualifications'] = this.qualifications;
    }
    if (typeof this.goals !== 'undefined') {
      toReturn['goals'] = this.goals;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.emailType !== 'undefined') {
      toReturn['emailType'] = this.emailType;
    }
    if (typeof this.hasWebsite !== 'undefined') {
      toReturn['hasWebsite'] = this.hasWebsite;
    }
    if (typeof this.isSelfSignup !== 'undefined') {
      toReturn['isSelfSignup'] = this.isSelfSignup;
    }
    if (typeof this.tagFilter !== 'undefined') {
      toReturn['tagFilter'] = this.tagFilter;
    }
    if (typeof this.isAmountOwing !== 'undefined') {
      toReturn['isAmountOwing'] = this.isAmountOwing;
    }
    if (typeof this.subscriptionTier !== 'undefined') {
      toReturn['subscriptionTier'] = this.subscriptionTier;
    }
    if (typeof this.subscriptionChanged !== 'undefined') {
      toReturn['subscriptionChanged'] = this.subscriptionChanged;
    }
    if (typeof this.conversionPoints !== 'undefined') {
      toReturn['conversionPoints'] = this.conversionPoints;
    }
    if (typeof this.leadSources !== 'undefined') {
      toReturn['leadSources'] = this.leadSources;
    }
    if (typeof this.contractStatus !== 'undefined') {
      toReturn['contractStatus'] = this.contractStatus;
    }
    if (typeof this.isReengagingAccount !== 'undefined') {
      toReturn['isReengagingAccount'] = this.isReengagingAccount;
    }
    if (typeof this.anySnapshotsGenerated !== 'undefined') {
      toReturn['anySnapshotsGenerated'] = this.anySnapshotsGenerated;
    }
    if (typeof this.anyPaidProductsActivated !== 'undefined') {
      toReturn['anyPaidProductsActivated'] = this.anyPaidProductsActivated;
    }
    if (typeof this.anyAccountsCreated !== 'undefined') {
      toReturn['anyAccountsCreated'] = this.anyAccountsCreated;
    }
    if (typeof this.anyPaymentCard !== 'undefined') {
      toReturn['anyPaymentCard'] = this.anyPaymentCard;
    }
    if (typeof this.marketingClassifications !== 'undefined') {
      toReturn['marketingClassifications'] = this.marketingClassifications;
    }
    if (typeof this.leadProgramDescriptions !== 'undefined') {
      toReturn['leadProgramDescriptions'] = this.leadProgramDescriptions;
    }
    if (typeof this.emptyMarketingClassification !== 'undefined') {
      toReturn['emptyMarketingClassification'] = this.emptyMarketingClassification;
    }
    if (typeof this.subscriptionTierId !== 'undefined') {
      toReturn['subscriptionTierId'] = this.subscriptionTierId;
    }
    if (typeof this.numberOfEmployees !== 'undefined') {
      toReturn['numberOfEmployees'] = this.numberOfEmployees;
    }
    if (typeof this.leadTier !== 'undefined') {
      toReturn['leadTier'] = this.leadTier;
    }
    if (typeof this.companySizeCohort !== 'undefined') {
      toReturn['companySizeCohort'] = this.companySizeCohort;
    }
    if (typeof this.utmInfo !== 'undefined' && this.utmInfo !== null) {
      toReturn['utmInfo'] = 'toApiJson' in this.utmInfo ? this.utmInfo.toApiJson() : this.utmInfo;
    }
    if (typeof this.adName !== 'undefined') {
      toReturn['adName'] = this.adName;
    }
    if (typeof this.segment !== 'undefined') {
      toReturn['segment'] = this.segment;
    }
    if (typeof this.mainVertical !== 'undefined') {
      toReturn['mainVertical'] = this.mainVertical;
    }
    if (typeof this.partnerServiceLevel !== 'undefined') {
      toReturn['partnerServiceLevel'] = this.partnerServiceLevel;
    }
    if (typeof this.inboundOutbound !== 'undefined') {
      toReturn['inboundOutbound'] = this.inboundOutbound;
    }
    if (typeof this.isMultiLocation !== 'undefined') {
      toReturn['isMultiLocation'] = this.isMultiLocation;
    }
    if (typeof this.numberOfDigitalSalespeople !== 'undefined') {
      toReturn['numberOfDigitalSalespeople'] = this.numberOfDigitalSalespeople;
    }
    if (typeof this.numberOfSalespeople !== 'undefined') {
      toReturn['numberOfSalespeople'] = this.numberOfSalespeople;
    }
    if (typeof this.archivedFilter !== 'undefined') {
      toReturn['archivedFilter'] = this.archivedFilter;
    }
    if (typeof this.billedClients !== 'undefined') {
      toReturn['billedClients'] = this.billedClients;
    }
    if (typeof this.accountsCreated !== 'undefined') {
      toReturn['accountsCreated'] = this.accountsCreated;
    }
    if (typeof this.paidProducts !== 'undefined') {
      toReturn['paidProducts'] = this.paidProducts;
    }
    if (typeof this.hasPid !== 'undefined') {
      toReturn['hasPid'] = this.hasPid;
    }
    if (typeof this.hasPidFilter !== 'undefined') {
      toReturn['hasPidFilter'] = this.hasPidFilter;
    }
    return toReturn;
  }
}
class Attributes {
  static fromProto(proto) {
    let m = new Attributes();
    m = Object.assign(m, proto);
    if (proto.emailType) {
      m.emailType = enumStringToValue$f(EmailType, proto.emailType);
    }
    if (proto.lastVisit) {
      m.lastVisit = new Date(proto.lastVisit);
    }
    if (proto.lastSalesActivityDate) {
      m.lastSalesActivityDate = new Date(proto.lastSalesActivityDate);
    }
    if (proto.paymentInfo) {
      m.paymentInfo = PaymentInfo.fromProto(proto.paymentInfo);
    }
    if (proto.subscriptionTier) {
      m.subscriptionTier = enumStringToValue$f(SubscriptionTier, proto.subscriptionTier);
    }
    if (proto.contractSignedDate) {
      m.contractSignedDate = new Date(proto.contractSignedDate);
    }
    if (proto.previousSubscriptionTier) {
      m.previousSubscriptionTier = enumStringToValue$f(SubscriptionTier, proto.previousSubscriptionTier);
    }
    if (proto.dunningAttempts) {
      m.dunningAttempts = parseInt(proto.dunningAttempts, 10);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.contractStatus) {
      m.contractStatus = enumStringToValue$f(ContractStatus, proto.contractStatus);
    }
    if (proto.lastMonthRecognizedRevenue) {
      m.lastMonthRecognizedRevenue = Money.fromProto(proto.lastMonthRecognizedRevenue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.numberOfEmployees !== 'undefined') {
      toReturn['numberOfEmployees'] = this.numberOfEmployees;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.emailType !== 'undefined') {
      toReturn['emailType'] = this.emailType;
    }
    if (typeof this.qualification !== 'undefined') {
      toReturn['qualification'] = this.qualification;
    }
    if (typeof this.goal !== 'undefined') {
      toReturn['goal'] = this.goal;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.lastVisit !== 'undefined' && this.lastVisit !== null) {
      toReturn['lastVisit'] = 'toApiJson' in this.lastVisit ? this.lastVisit.toApiJson() : this.lastVisit;
    }
    if (typeof this.lastSalesActivityDate !== 'undefined' && this.lastSalesActivityDate !== null) {
      toReturn['lastSalesActivityDate'] = 'toApiJson' in this.lastSalesActivityDate ? this.lastSalesActivityDate.toApiJson() : this.lastSalesActivityDate;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.paymentInfo !== 'undefined' && this.paymentInfo !== null) {
      toReturn['paymentInfo'] = 'toApiJson' in this.paymentInfo ? this.paymentInfo.toApiJson() : this.paymentInfo;
    }
    if (typeof this.subscriptionTier !== 'undefined') {
      toReturn['subscriptionTier'] = this.subscriptionTier;
    }
    if (typeof this.contractSignedDate !== 'undefined' && this.contractSignedDate !== null) {
      toReturn['contractSignedDate'] = 'toApiJson' in this.contractSignedDate ? this.contractSignedDate.toApiJson() : this.contractSignedDate;
    }
    if (typeof this.previousSubscriptionTier !== 'undefined') {
      toReturn['previousSubscriptionTier'] = this.previousSubscriptionTier;
    }
    if (typeof this.dunningAttempts !== 'undefined') {
      toReturn['dunningAttempts'] = this.dunningAttempts;
    }
    if (typeof this.conversionPoint !== 'undefined') {
      toReturn['conversionPoint'] = this.conversionPoint;
    }
    if (typeof this.leadSource !== 'undefined') {
      toReturn['leadSource'] = this.leadSource;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.contractStatus !== 'undefined') {
      toReturn['contractStatus'] = this.contractStatus;
    }
    if (typeof this.hasPaymentCard !== 'undefined') {
      toReturn['hasPaymentCard'] = this.hasPaymentCard;
    }
    if (typeof this.marketingClassification !== 'undefined') {
      toReturn['marketingClassification'] = this.marketingClassification;
    }
    if (typeof this.leadProgramDescription !== 'undefined') {
      toReturn['leadProgramDescription'] = this.leadProgramDescription;
    }
    if (typeof this.subscriptionTierId !== 'undefined') {
      toReturn['subscriptionTierId'] = this.subscriptionTierId;
    }
    if (typeof this.previousSubscriptionTierId !== 'undefined') {
      toReturn['previousSubscriptionTierId'] = this.previousSubscriptionTierId;
    }
    if (typeof this.lastMonthRecognizedRevenue !== 'undefined' && this.lastMonthRecognizedRevenue !== null) {
      toReturn['lastMonthRecognizedRevenue'] = 'toApiJson' in this.lastMonthRecognizedRevenue ? this.lastMonthRecognizedRevenue.toApiJson() : this.lastMonthRecognizedRevenue;
    }
    if (typeof this.isArchived !== 'undefined') {
      toReturn['isArchived'] = this.isArchived;
    }
    return toReturn;
  }
}
class BackfillLeadAttributionForBusinessRequest {
  static fromProto(proto) {
    let m = new BackfillLeadAttributionForBusinessRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.marketingFormId !== 'undefined') {
      toReturn['marketingFormId'] = this.marketingFormId;
    }
    return toReturn;
  }
}
class ExportToCSVRequest {
  static fromProto(proto) {
    let m = new ExportToCSVRequest();
    m = Object.assign(m, proto);
    if (proto.listProspectsRequest) {
      m.listProspectsRequest = ListPartnerProspectsRequestInternal.fromProto(proto.listProspectsRequest);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listProspectsRequest !== 'undefined' && this.listProspectsRequest !== null) {
      toReturn['listProspectsRequest'] = 'toApiJson' in this.listProspectsRequest ? this.listProspectsRequest.toApiJson() : this.listProspectsRequest;
    }
    if (typeof this.displayedColumns !== 'undefined') {
      toReturn['displayedColumns'] = this.displayedColumns;
    }
    return toReturn;
  }
}
class Filters {
  static fromProto(proto) {
    let m = new Filters();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$f(Status, v));
    }
    if (proto.attributeFilters) {
      m.attributeFilters = AttributeFilters.fromProto(proto.attributeFilters);
    }
    if (proto.latestSalesActivityFilter) {
      m.latestSalesActivityFilter = enumStringToValue$f(LatestSalesActivityOption, proto.latestSalesActivityFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesTeam !== 'undefined') {
      toReturn['salesTeam'] = this.salesTeam;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.searchText !== 'undefined') {
      toReturn['searchText'] = this.searchText;
    }
    if (typeof this.attributeFilters !== 'undefined' && this.attributeFilters !== null) {
      toReturn['attributeFilters'] = 'toApiJson' in this.attributeFilters ? this.attributeFilters.toApiJson() : this.attributeFilters;
    }
    if (typeof this.assignedSalesperson !== 'undefined') {
      toReturn['assignedSalesperson'] = this.assignedSalesperson;
    }
    if (typeof this.latestSalesActivityFilter !== 'undefined') {
      toReturn['latestSalesActivityFilter'] = this.latestSalesActivityFilter;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class FindDuplicatePartnerProspectsRequest {
  static fromProto(proto) {
    let m = new FindDuplicatePartnerProspectsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    return toReturn;
  }
}
class FindDuplicatePartnerProspectsResponse {
  static fromProto(proto) {
    let m = new FindDuplicatePartnerProspectsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectBusinessIds !== 'undefined') {
      toReturn['prospectBusinessIds'] = this.prospectBusinessIds;
    }
    return toReturn;
  }
}
class ListPartnerProspectsRequestInternal {
  static fromProto(proto) {
    let m = new ListPartnerProspectsRequestInternal();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedRequestOptions.fromProto(proto.paging);
    }
    if (proto.dateRange) {
      m.dateRange = enumStringToValue$f(DateRange, proto.dateRange);
    }
    if (proto.filters) {
      m.filters = Filters.fromProto(proto.filters);
    }
    if (proto.multiSortingOptions) {
      m.multiSortingOptions = MultiSortingOptions.fromProto(proto.multiSortingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.dateRange !== 'undefined') {
      toReturn['dateRange'] = this.dateRange;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.multiSortingOptions !== 'undefined' && this.multiSortingOptions !== null) {
      toReturn['multiSortingOptions'] = 'toApiJson' in this.multiSortingOptions ? this.multiSortingOptions.toApiJson() : this.multiSortingOptions;
    }
    return toReturn;
  }
}
class ListPartnerProspectsResponse {
  static fromProto(proto) {
    let m = new ListPartnerProspectsResponse();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedResponseMetadata.fromProto(proto.paging);
    }
    if (proto.partnerProspects) {
      m.partnerProspects = proto.partnerProspects.map(PartnerProspect.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.partnerProspects !== 'undefined' && this.partnerProspects !== null) {
      toReturn['partnerProspects'] = 'toApiJson' in this.partnerProspects ? this.partnerProspects.toApiJson() : this.partnerProspects;
    }
    return toReturn;
  }
}
class Metrics {
  static fromProto(proto) {
    let m = new Metrics();
    m = Object.assign(m, proto);
    if (proto.daysActiveInPlatform) {
      m.daysActiveInPlatform = parseInt(proto.daysActiveInPlatform, 10);
    }
    if (proto.activePaidProductsDelta) {
      m.activePaidProductsDelta = parseInt(proto.activePaidProductsDelta, 10);
    }
    if (proto.accountsDelta) {
      m.accountsDelta = parseInt(proto.accountsDelta, 10);
    }
    if (proto.generatedSnapshotsDelta) {
      m.generatedSnapshotsDelta = parseInt(proto.generatedSnapshotsDelta, 10);
    }
    if (proto.openOpportunities) {
      m.openOpportunities = parseInt(proto.openOpportunities, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.daysActiveInPlatform !== 'undefined') {
      toReturn['daysActiveInPlatform'] = this.daysActiveInPlatform;
    }
    if (typeof this.activePaidProductsDelta !== 'undefined') {
      toReturn['activePaidProductsDelta'] = this.activePaidProductsDelta;
    }
    if (typeof this.accountsDelta !== 'undefined') {
      toReturn['accountsDelta'] = this.accountsDelta;
    }
    if (typeof this.generatedSnapshotsDelta !== 'undefined') {
      toReturn['generatedSnapshotsDelta'] = this.generatedSnapshotsDelta;
    }
    if (typeof this.openOpportunities !== 'undefined') {
      toReturn['openOpportunities'] = this.openOpportunities;
    }
    return toReturn;
  }
}
class PartnerProspect {
  static fromProto(proto) {
    let m = new PartnerProspect();
    m = Object.assign(m, proto);
    if (proto.hotness) {
      m.hotness = parseInt(proto.hotness, 10);
    }
    if (proto.status) {
      m.status = enumStringToValue$f(Status, proto.status);
    }
    if (proto.metrics) {
      m.metrics = Metrics.fromProto(proto.metrics);
    }
    if (proto.attributes) {
      m.attributes = Attributes.fromProto(proto.attributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.hotness !== 'undefined') {
      toReturn['hotness'] = this.hotness;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.unreadActivity !== 'undefined') {
      toReturn['unreadActivity'] = this.unreadActivity;
    }
    if (typeof this.assignee !== 'undefined') {
      toReturn['assignee'] = this.assignee;
    }
    if (typeof this.metrics !== 'undefined' && this.metrics !== null) {
      toReturn['metrics'] = 'toApiJson' in this.metrics ? this.metrics.toApiJson() : this.metrics;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}
class PaymentInfo {
  static fromProto(proto) {
    let m = new PaymentInfo();
    m = Object.assign(m, proto);
    if (proto.lastFailedPaymentDate) {
      m.lastFailedPaymentDate = new Date(proto.lastFailedPaymentDate);
    }
    if (proto.firstFailedPaymentDate) {
      m.firstFailedPaymentDate = new Date(proto.firstFailedPaymentDate);
    }
    if (proto.totalAmountOwing) {
      m.totalAmountOwing = Money.fromProto(proto.totalAmountOwing);
    }
    if (proto.lastSuccessfulPaymentDate) {
      m.lastSuccessfulPaymentDate = new Date(proto.lastSuccessfulPaymentDate);
    }
    if (proto.firstSuccessfulPaymentDate) {
      m.firstSuccessfulPaymentDate = new Date(proto.firstSuccessfulPaymentDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lastFailedPaymentDate !== 'undefined' && this.lastFailedPaymentDate !== null) {
      toReturn['lastFailedPaymentDate'] = 'toApiJson' in this.lastFailedPaymentDate ? this.lastFailedPaymentDate.toApiJson() : this.lastFailedPaymentDate;
    }
    if (typeof this.firstFailedPaymentDate !== 'undefined' && this.firstFailedPaymentDate !== null) {
      toReturn['firstFailedPaymentDate'] = 'toApiJson' in this.firstFailedPaymentDate ? this.firstFailedPaymentDate.toApiJson() : this.firstFailedPaymentDate;
    }
    if (typeof this.totalAmountOwing !== 'undefined' && this.totalAmountOwing !== null) {
      toReturn['totalAmountOwing'] = 'toApiJson' in this.totalAmountOwing ? this.totalAmountOwing.toApiJson() : this.totalAmountOwing;
    }
    if (typeof this.lastSuccessfulPaymentDate !== 'undefined' && this.lastSuccessfulPaymentDate !== null) {
      toReturn['lastSuccessfulPaymentDate'] = 'toApiJson' in this.lastSuccessfulPaymentDate ? this.lastSuccessfulPaymentDate.toApiJson() : this.lastSuccessfulPaymentDate;
    }
    if (typeof this.firstSuccessfulPaymentDate !== 'undefined' && this.firstSuccessfulPaymentDate !== null) {
      toReturn['firstSuccessfulPaymentDate'] = 'toApiJson' in this.firstSuccessfulPaymentDate ? this.firstSuccessfulPaymentDate.toApiJson() : this.firstSuccessfulPaymentDate;
    }
    return toReturn;
  }
}
class UtmFilters {
  static fromProto(proto) {
    let m = new UtmFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaign !== 'undefined') {
      toReturn['campaign'] = this.campaign;
    }
    if (typeof this.medium !== 'undefined') {
      toReturn['medium'] = this.medium;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.term !== 'undefined') {
      toReturn['term'] = this.term;
    }
    return toReturn;
  }
}
function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Account {
  static fromProto(proto) {
    let m = new Account();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = AccountAttributes.fromProto(proto.attributes);
    }
    if (proto.metrics) {
      m.metrics = AccountMetrics.fromProto(proto.metrics);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.assignees !== 'undefined') {
      toReturn['assignees'] = this.assignees;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.metrics !== 'undefined' && this.metrics !== null) {
      toReturn['metrics'] = 'toApiJson' in this.metrics ? this.metrics.toApiJson() : this.metrics;
    }
    return toReturn;
  }
}
class AccountAttributeFilters {
  static fromProto(proto) {
    let m = new AccountAttributeFilters();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$e(Status, v));
    }
    if (proto.archivedFilter) {
      m.archivedFilter = enumStringToValue$e(ArchivedFilter, proto.archivedFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.archivedFilter !== 'undefined') {
      toReturn['archivedFilter'] = this.archivedFilter;
    }
    return toReturn;
  }
}
class AccountAttributes {
  static fromProto(proto) {
    let m = new AccountAttributes();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$e(Status, proto.status);
    }
    if (proto.lastSalesActivityDate) {
      m.lastSalesActivityDate = new Date(proto.lastSalesActivityDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.unreadActivity !== 'undefined') {
      toReturn['unreadActivity'] = this.unreadActivity;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.lastSalesActivityDate !== 'undefined' && this.lastSalesActivityDate !== null) {
      toReturn['lastSalesActivityDate'] = 'toApiJson' in this.lastSalesActivityDate ? this.lastSalesActivityDate.toApiJson() : this.lastSalesActivityDate;
    }
    if (typeof this.facebookPageId !== 'undefined') {
      toReturn['facebookPageId'] = this.facebookPageId;
    }
    if (typeof this.googleMyBusinessPlaceId !== 'undefined') {
      toReturn['googleMyBusinessPlaceId'] = this.googleMyBusinessPlaceId;
    }
    if (typeof this.isArchived !== 'undefined') {
      toReturn['isArchived'] = this.isArchived;
    }
    return toReturn;
  }
}
class AccountFilters {
  static fromProto(proto) {
    let m = new AccountFilters();
    m = Object.assign(m, proto);
    if (proto.attributeFilters) {
      m.attributeFilters = AccountAttributeFilters.fromProto(proto.attributeFilters);
    }
    if (proto.latestSalesActivityFilter) {
      m.latestSalesActivityFilter = enumStringToValue$e(LatestSalesActivityOption, proto.latestSalesActivityFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchText !== 'undefined') {
      toReturn['searchText'] = this.searchText;
    }
    if (typeof this.attributeFilters !== 'undefined' && this.attributeFilters !== null) {
      toReturn['attributeFilters'] = 'toApiJson' in this.attributeFilters ? this.attributeFilters.toApiJson() : this.attributeFilters;
    }
    if (typeof this.assignee !== 'undefined') {
      toReturn['assignee'] = this.assignee;
    }
    if (typeof this.latestSalesActivityFilter !== 'undefined') {
      toReturn['latestSalesActivityFilter'] = this.latestSalesActivityFilter;
    }
    return toReturn;
  }
}
class AccountMetrics {
  static fromProto(proto) {
    let m = new AccountMetrics();
    m = Object.assign(m, proto);
    if (proto.lockHitCount) {
      m.lockHitCount = parseInt(proto.lockHitCount, 10);
    }
    if (proto.contactSalesCount) {
      m.contactSalesCount = parseInt(proto.contactSalesCount, 10);
    }
    if (proto.updateBusinessProfileCount) {
      m.updateBusinessProfileCount = parseInt(proto.updateBusinessProfileCount, 10);
    }
    if (proto.viewExecReportCount) {
      m.viewExecReportCount = parseInt(proto.viewExecReportCount, 10);
    }
    if (proto.createSingleCustomerCount) {
      m.createSingleCustomerCount = parseInt(proto.createSingleCustomerCount, 10);
    }
    if (proto.createBulkCustomerCount) {
      m.createBulkCustomerCount = parseInt(proto.createBulkCustomerCount, 10);
    }
    if (proto.viewStoreCount) {
      m.viewStoreCount = parseInt(proto.viewStoreCount, 10);
    }
    if (proto.interestInPackageOrProduct) {
      m.interestInPackageOrProduct = parseInt(proto.interestInPackageOrProduct, 10);
    }
    if (proto.numberOfDaysUserWasActive) {
      m.numberOfDaysUserWasActive = parseInt(proto.numberOfDaysUserWasActive, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lockHitCount !== 'undefined') {
      toReturn['lockHitCount'] = this.lockHitCount;
    }
    if (typeof this.contactSalesCount !== 'undefined') {
      toReturn['contactSalesCount'] = this.contactSalesCount;
    }
    if (typeof this.updateBusinessProfileCount !== 'undefined') {
      toReturn['updateBusinessProfileCount'] = this.updateBusinessProfileCount;
    }
    if (typeof this.viewExecReportCount !== 'undefined') {
      toReturn['viewExecReportCount'] = this.viewExecReportCount;
    }
    if (typeof this.createSingleCustomerCount !== 'undefined') {
      toReturn['createSingleCustomerCount'] = this.createSingleCustomerCount;
    }
    if (typeof this.createBulkCustomerCount !== 'undefined') {
      toReturn['createBulkCustomerCount'] = this.createBulkCustomerCount;
    }
    if (typeof this.viewStoreCount !== 'undefined') {
      toReturn['viewStoreCount'] = this.viewStoreCount;
    }
    if (typeof this.interestInPackageOrProduct !== 'undefined') {
      toReturn['interestInPackageOrProduct'] = this.interestInPackageOrProduct;
    }
    if (typeof this.numberOfDaysUserWasActive !== 'undefined') {
      toReturn['numberOfDaysUserWasActive'] = this.numberOfDaysUserWasActive;
    }
    return toReturn;
  }
}
class ListAccountAnalyticsRequest {
  static fromProto(proto) {
    let m = new ListAccountAnalyticsRequest();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedRequestOptions.fromProto(proto.paging);
    }
    if (proto.filters) {
      m.filters = AccountFilters.fromProto(proto.filters);
    }
    if (proto.sorting) {
      m.sorting = MultiSortingOptions.fromProto(proto.sorting);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.sorting !== 'undefined' && this.sorting !== null) {
      toReturn['sorting'] = 'toApiJson' in this.sorting ? this.sorting.toApiJson() : this.sorting;
    }
    return toReturn;
  }
}
class ListAccountAnalyticsResponse {
  static fromProto(proto) {
    let m = new ListAccountAnalyticsResponse();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedResponseMetadata.fromProto(proto.paging);
    }
    if (proto.accounts) {
      m.accounts = proto.accounts.map(Account.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.accounts !== 'undefined' && this.accounts !== null) {
      toReturn['accounts'] = 'toApiJson' in this.accounts ? this.accounts.toApiJson() : this.accounts;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AnalyticsPresetView {
  static fromProto(proto) {
    let m = new AnalyticsPresetView();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.viewId !== 'undefined') {
      toReturn['viewId'] = this.viewId;
    }
    if (typeof this.viewName !== 'undefined') {
      toReturn['viewName'] = this.viewName;
    }
    if (typeof this.viewDescription !== 'undefined') {
      toReturn['viewDescription'] = this.viewDescription;
    }
    if (typeof this.attributeFiltersJson !== 'undefined') {
      toReturn['attributeFiltersJson'] = this.attributeFiltersJson;
    }
    if (typeof this.sortingJson !== 'undefined') {
      toReturn['sortingJson'] = this.sortingJson;
    }
    return toReturn;
  }
}
class ListAnalyticsPresetViewRequest {
  static fromProto(proto) {
    let m = new ListAnalyticsPresetViewRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ListAnalyticsPresetViewResponse {
  static fromProto(proto) {
    let m = new ListAnalyticsPresetViewResponse();
    m = Object.assign(m, proto);
    if (proto.analyticsPresetView) {
      m.analyticsPresetView = proto.analyticsPresetView.map(AnalyticsPresetView.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.analyticsPresetView !== 'undefined' && this.analyticsPresetView !== null) {
      toReturn['analyticsPresetView'] = 'toApiJson' in this.analyticsPresetView ? this.analyticsPresetView.toApiJson() : this.analyticsPresetView;
    }
    return toReturn;
  }
}
class PutAnalyticsPresetViewResponse {
  static fromProto(proto) {
    let m = new PutAnalyticsPresetViewResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Affiliate {
  static fromProto(proto) {
    let m = new Affiliate();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$c(StatusType, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.paypalEmail !== 'undefined') {
      toReturn['paypalEmail'] = this.paypalEmail;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.websiteUrl !== 'undefined') {
      toReturn['websiteUrl'] = this.websiteUrl;
    }
    if (typeof this.howWillYouPromoteVendasta !== 'undefined') {
      toReturn['howWillYouPromoteVendasta'] = this.howWillYouPromoteVendasta;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.userHasSigningAuthority !== 'undefined') {
      toReturn['userHasSigningAuthority'] = this.userHasSigningAuthority;
    }
    if (typeof this.acceptedTermsOfServiceVersion !== 'undefined') {
      toReturn['acceptedTermsOfServiceVersion'] = this.acceptedTermsOfServiceVersion;
    }
    if (typeof this.acceptedTermsOfService !== 'undefined') {
      toReturn['acceptedTermsOfService'] = this.acceptedTermsOfService;
    }
    return toReturn;
  }
}
class AffiliatePaymentAmounts {
  static fromProto(proto) {
    let m = new AffiliatePaymentAmounts();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    if (typeof this.freeMonthlyUsdCents !== 'undefined') {
      toReturn['freeMonthlyUsdCents'] = this.freeMonthlyUsdCents;
    }
    if (typeof this.freeYearlyUsdCents !== 'undefined') {
      toReturn['freeYearlyUsdCents'] = this.freeYearlyUsdCents;
    }
    if (typeof this.startupMonthlyUsdCents !== 'undefined') {
      toReturn['startupMonthlyUsdCents'] = this.startupMonthlyUsdCents;
    }
    if (typeof this.startupYearlyUsdCents !== 'undefined') {
      toReturn['startupYearlyUsdCents'] = this.startupYearlyUsdCents;
    }
    if (typeof this.essentialsMonthlyUsdCents !== 'undefined') {
      toReturn['essentialsMonthlyUsdCents'] = this.essentialsMonthlyUsdCents;
    }
    if (typeof this.essentialsYearlyUsdCents !== 'undefined') {
      toReturn['essentialsYearlyUsdCents'] = this.essentialsYearlyUsdCents;
    }
    if (typeof this.growthMonthlyUsdCents !== 'undefined') {
      toReturn['growthMonthlyUsdCents'] = this.growthMonthlyUsdCents;
    }
    if (typeof this.growthYearlyUsdCents !== 'undefined') {
      toReturn['growthYearlyUsdCents'] = this.growthYearlyUsdCents;
    }
    if (typeof this.scaleMonthlyUsdCents !== 'undefined') {
      toReturn['scaleMonthlyUsdCents'] = this.scaleMonthlyUsdCents;
    }
    if (typeof this.scaleYearlyUsdCents !== 'undefined') {
      toReturn['scaleYearlyUsdCents'] = this.scaleYearlyUsdCents;
    }
    return toReturn;
  }
}
class AffiliatePaymentReportLineItem {
  static fromProto(proto) {
    let m = new AffiliatePaymentReportLineItem();
    m = Object.assign(m, proto);
    if (proto.subscriptionStartDate) {
      m.subscriptionStartDate = new Date(proto.subscriptionStartDate);
    }
    if (proto.paymentAmount) {
      m.paymentAmount = Money.fromProto(proto.paymentAmount);
    }
    if (proto.firstPayByDate) {
      m.firstPayByDate = new Date(proto.firstPayByDate);
    }
    if (proto.secondPayByDate) {
      m.secondPayByDate = new Date(proto.secondPayByDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscriptionTier !== 'undefined') {
      toReturn['subscriptionTier'] = this.subscriptionTier;
    }
    if (typeof this.subscriptionStartDate !== 'undefined' && this.subscriptionStartDate !== null) {
      toReturn['subscriptionStartDate'] = 'toApiJson' in this.subscriptionStartDate ? this.subscriptionStartDate.toApiJson() : this.subscriptionStartDate;
    }
    if (typeof this.paymentAmount !== 'undefined' && this.paymentAmount !== null) {
      toReturn['paymentAmount'] = 'toApiJson' in this.paymentAmount ? this.paymentAmount.toApiJson() : this.paymentAmount;
    }
    if (typeof this.firstPayByDate !== 'undefined' && this.firstPayByDate !== null) {
      toReturn['firstPayByDate'] = 'toApiJson' in this.firstPayByDate ? this.firstPayByDate.toApiJson() : this.firstPayByDate;
    }
    if (typeof this.secondPayByDate !== 'undefined' && this.secondPayByDate !== null) {
      toReturn['secondPayByDate'] = 'toApiJson' in this.secondPayByDate ? this.secondPayByDate.toApiJson() : this.secondPayByDate;
    }
    if (typeof this.subscriptionContractLength !== 'undefined') {
      toReturn['subscriptionContractLength'] = this.subscriptionContractLength;
    }
    return toReturn;
  }
}
class CreateAffiliateRequest {
  static fromProto(proto) {
    let m = new CreateAffiliateRequest();
    m = Object.assign(m, proto);
    if (proto.affiliate) {
      m.affiliate = Affiliate.fromProto(proto.affiliate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliate !== 'undefined' && this.affiliate !== null) {
      toReturn['affiliate'] = 'toApiJson' in this.affiliate ? this.affiliate.toApiJson() : this.affiliate;
    }
    if (typeof this.isPaidPartner !== 'undefined') {
      toReturn['isPaidPartner'] = this.isPaidPartner;
    }
    return toReturn;
  }
}
class CreateAffiliateResponse {
  static fromProto(proto) {
    let m = new CreateAffiliateResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class CreateTermsOfServiceRequest {
  static fromProto(proto) {
    let m = new CreateTermsOfServiceRequest();
    m = Object.assign(m, proto);
    if (proto.termOfService) {
      m.termOfService = TermsOfService.fromProto(proto.termOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.termOfService !== 'undefined' && this.termOfService !== null) {
      toReturn['termOfService'] = 'toApiJson' in this.termOfService ? this.termOfService.toApiJson() : this.termOfService;
    }
    return toReturn;
  }
}
class CreateTermsOfServiceResponse {
  static fromProto(proto) {
    let m = new CreateTermsOfServiceResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetAffiliatePaymentAmountsRequest {
  static fromProto(proto) {
    let m = new GetAffiliatePaymentAmountsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    return toReturn;
  }
}
class GetAffiliatePaymentAmountsResponse {
  static fromProto(proto) {
    let m = new GetAffiliatePaymentAmountsResponse();
    m = Object.assign(m, proto);
    if (proto.affiliatePaymentAmmounts) {
      m.affiliatePaymentAmmounts = AffiliatePaymentAmounts.fromProto(proto.affiliatePaymentAmmounts);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliatePaymentAmmounts !== 'undefined' && this.affiliatePaymentAmmounts !== null) {
      toReturn['affiliatePaymentAmmounts'] = 'toApiJson' in this.affiliatePaymentAmmounts ? this.affiliatePaymentAmmounts.toApiJson() : this.affiliatePaymentAmmounts;
    }
    return toReturn;
  }
}
class GetAffiliatePaymentReportRequest {
  static fromProto(proto) {
    let m = new GetAffiliatePaymentReportRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    return toReturn;
  }
}
class GetAffiliatePaymentReportResponse {
  static fromProto(proto) {
    let m = new GetAffiliatePaymentReportResponse();
    m = Object.assign(m, proto);
    if (proto.paymentReport) {
      m.paymentReport = proto.paymentReport.map(AffiliatePaymentReportLineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paymentReport !== 'undefined' && this.paymentReport !== null) {
      toReturn['paymentReport'] = 'toApiJson' in this.paymentReport ? this.paymentReport.toApiJson() : this.paymentReport;
    }
    return toReturn;
  }
}
class GetAffiliateRequest {
  static fromProto(proto) {
    let m = new GetAffiliateRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    return toReturn;
  }
}
class GetAffiliateResponse {
  static fromProto(proto) {
    let m = new GetAffiliateResponse();
    m = Object.assign(m, proto);
    if (proto.affiliate) {
      m.affiliate = Affiliate.fromProto(proto.affiliate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliate !== 'undefined' && this.affiliate !== null) {
      toReturn['affiliate'] = 'toApiJson' in this.affiliate ? this.affiliate.toApiJson() : this.affiliate;
    }
    return toReturn;
  }
}
class GetTermsOfServiceRequest {
  static fromProto(proto) {
    let m = new GetTermsOfServiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetTermsOfServiceResponse {
  static fromProto(proto) {
    let m = new GetTermsOfServiceResponse();
    m = Object.assign(m, proto);
    if (proto.termOfService) {
      m.termOfService = TermsOfService.fromProto(proto.termOfService);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.termOfService !== 'undefined' && this.termOfService !== null) {
      toReturn['termOfService'] = 'toApiJson' in this.termOfService ? this.termOfService.toApiJson() : this.termOfService;
    }
    return toReturn;
  }
}
class ListAffiliatesRequest {
  static fromProto(proto) {
    let m = new ListAffiliatesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageIndex !== 'undefined') {
      toReturn['pageIndex'] = this.pageIndex;
    }
    return toReturn;
  }
}
class ListAffiliatesResponse {
  static fromProto(proto) {
    let m = new ListAffiliatesResponse();
    m = Object.assign(m, proto);
    if (proto.affiliates) {
      m.affiliates = proto.affiliates.map(Affiliate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliates !== 'undefined' && this.affiliates !== null) {
      toReturn['affiliates'] = 'toApiJson' in this.affiliates ? this.affiliates.toApiJson() : this.affiliates;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class PutAffiliatePaymentAmountsRequest {
  static fromProto(proto) {
    let m = new PutAffiliatePaymentAmountsRequest();
    m = Object.assign(m, proto);
    if (proto.affiliatePaymentAmmounts) {
      m.affiliatePaymentAmmounts = AffiliatePaymentAmounts.fromProto(proto.affiliatePaymentAmmounts);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliatePaymentAmmounts !== 'undefined' && this.affiliatePaymentAmmounts !== null) {
      toReturn['affiliatePaymentAmmounts'] = 'toApiJson' in this.affiliatePaymentAmmounts ? this.affiliatePaymentAmmounts.toApiJson() : this.affiliatePaymentAmmounts;
    }
    return toReturn;
  }
}
class PutAffiliatePaymentAmountsResponse {
  static fromProto(proto) {
    let m = new PutAffiliatePaymentAmountsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class TermsOfService {
  static fromProto(proto) {
    let m = new TermsOfService();
    m = Object.assign(m, proto);
    if (proto.createDate) {
      m.createDate = new Date(proto.createDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.terms !== 'undefined') {
      toReturn['terms'] = this.terms;
    }
    if (typeof this.createDate !== 'undefined' && this.createDate !== null) {
      toReturn['createDate'] = 'toApiJson' in this.createDate ? this.createDate.toApiJson() : this.createDate;
    }
    return toReturn;
  }
}
class UpdateAffiliateStatusRequest {
  static fromProto(proto) {
    let m = new UpdateAffiliateStatusRequest();
    m = Object.assign(m, proto);
    if (proto.approveStatus) {
      m.approveStatus = enumStringToValue$c(StatusType, proto.approveStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    if (typeof this.approveStatus !== 'undefined') {
      toReturn['approveStatus'] = this.approveStatus;
    }
    return toReturn;
  }
}
class UpdateAffiliateStatusResponse {
  static fromProto(proto) {
    let m = new UpdateAffiliateStatusResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class InitiateCampaignHistoryExportRequest {
  static fromProto(proto) {
    let m = new InitiateCampaignHistoryExportRequest();
    m = Object.assign(m, proto);
    if (proto.eventTypes) {
      m.eventTypes = proto.eventTypes.map(v => enumStringToValue$b(CampaignEventType, v));
    }
    if (proto.sortBy) {
      m.sortBy = enumStringToValue$b(InitiateCampaignHistoryExportRequestSortBy, proto.sortBy);
    }
    if (proto.orderBy) {
      m.orderBy = enumStringToValue$b(InitiateCampaignHistoryExportRequestOrderBy, proto.orderBy);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.campaignStepIds !== 'undefined') {
      toReturn['campaignStepIds'] = this.campaignStepIds;
    }
    if (typeof this.eventTypes !== 'undefined') {
      toReturn['eventTypes'] = this.eventTypes;
    }
    if (typeof this.sortBy !== 'undefined') {
      toReturn['sortBy'] = this.sortBy;
    }
    if (typeof this.orderBy !== 'undefined') {
      toReturn['orderBy'] = this.orderBy;
    }
    if (typeof this.uniqueEngagementOnly !== 'undefined') {
      toReturn['uniqueEngagementOnly'] = this.uniqueEngagementOnly;
    }
    return toReturn;
  }
}
class InitiateCampaignHistoryExportResponse {
  static fromProto(proto) {
    let m = new InitiateCampaignHistoryExportResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exportId !== 'undefined') {
      toReturn['exportId'] = this.exportId;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddPriorityToProspectRequest {
  static fromProto(proto) {
    let m = new AddPriorityToProspectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    if (typeof this.priorityId !== 'undefined') {
      toReturn['priorityId'] = this.priorityId;
    }
    return toReturn;
  }
}
class DeleteGoalsFromPartnerRequest {
  static fromProto(proto) {
    let m = new DeleteGoalsFromPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.goalIds !== 'undefined') {
      toReturn['goalIds'] = this.goalIds;
    }
    return toReturn;
  }
}
class DeletePrioritiesFromPartnerRequest {
  static fromProto(proto) {
    let m = new DeletePrioritiesFromPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.priorityIds !== 'undefined') {
      toReturn['priorityIds'] = this.priorityIds;
    }
    return toReturn;
  }
}
class EarlyWin {
  static fromProto(proto) {
    let m = new EarlyWin();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    return toReturn;
  }
}
class GetEarlyWinForProspectRequest {
  static fromProto(proto) {
    let m = new GetEarlyWinForProspectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    return toReturn;
  }
}
class GetEarlyWinForProspectResponse {
  static fromProto(proto) {
    let m = new GetEarlyWinForProspectResponse();
    m = Object.assign(m, proto);
    if (proto.earlyWin) {
      m.earlyWin = EarlyWin.fromProto(proto.earlyWin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.earlyWin !== 'undefined' && this.earlyWin !== null) {
      toReturn['earlyWin'] = 'toApiJson' in this.earlyWin ? this.earlyWin.toApiJson() : this.earlyWin;
    }
    return toReturn;
  }
}
class GetGoalForProspectRequest {
  static fromProto(proto) {
    let m = new GetGoalForProspectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    return toReturn;
  }
}
class GetGoalForProspectResponse {
  static fromProto(proto) {
    let m = new GetGoalForProspectResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goalId !== 'undefined') {
      toReturn['goalId'] = this.goalId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    return toReturn;
  }
}
class GetPriorityRequest {
  static fromProto(proto) {
    let m = new GetPriorityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    return toReturn;
  }
}
class GetPriorityResponse {
  static fromProto(proto) {
    let m = new GetPriorityResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    return toReturn;
  }
}
class Goal {
  static fromProto(proto) {
    let m = new Goal();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListGoalsForPartnerRequest {
  static fromProto(proto) {
    let m = new ListGoalsForPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListGoalsForPartnerResponse {
  static fromProto(proto) {
    let m = new ListGoalsForPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.goals) {
      m.goals = proto.goals.map(Goal.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goals !== 'undefined' && this.goals !== null) {
      toReturn['goals'] = 'toApiJson' in this.goals ? this.goals.toApiJson() : this.goals;
    }
    return toReturn;
  }
}
class ListPrioritiesForPartnerRequest {
  static fromProto(proto) {
    let m = new ListPrioritiesForPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListPrioritiesForPartnerResponse {
  static fromProto(proto) {
    let m = new ListPrioritiesForPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.priorities) {
      m.priorities = proto.priorities.map(Priority.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.priorities !== 'undefined' && this.priorities !== null) {
      toReturn['priorities'] = 'toApiJson' in this.priorities ? this.priorities.toApiJson() : this.priorities;
    }
    return toReturn;
  }
}
class ListPrioritiesForProspectRequest {
  static fromProto(proto) {
    let m = new ListPrioritiesForProspectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    return toReturn;
  }
}
class ListPrioritiesForProspectResponse {
  static fromProto(proto) {
    let m = new ListPrioritiesForProspectResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.priorityIds !== 'undefined') {
      toReturn['priorityIds'] = this.priorityIds;
    }
    return toReturn;
  }
}
class Priority {
  static fromProto(proto) {
    let m = new Priority();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class RemoveGoalFromProspectRequest {
  static fromProto(proto) {
    let m = new RemoveGoalFromProspectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    if (typeof this.goalId !== 'undefined') {
      toReturn['goalId'] = this.goalId;
    }
    return toReturn;
  }
}
class RemovePriorityFromProspectRequest {
  static fromProto(proto) {
    let m = new RemovePriorityFromProspectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    if (typeof this.priorityId !== 'undefined') {
      toReturn['priorityId'] = this.priorityId;
    }
    return toReturn;
  }
}
class ReplaceEarlyWinForProspectRequest {
  static fromProto(proto) {
    let m = new ReplaceEarlyWinForProspectRequest();
    m = Object.assign(m, proto);
    if (proto.earlyWin) {
      m.earlyWin = EarlyWin.fromProto(proto.earlyWin);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    if (typeof this.earlyWin !== 'undefined' && this.earlyWin !== null) {
      toReturn['earlyWin'] = 'toApiJson' in this.earlyWin ? this.earlyWin.toApiJson() : this.earlyWin;
    }
    return toReturn;
  }
}
class ReplaceGoalForProspectRequest {
  static fromProto(proto) {
    let m = new ReplaceGoalForProspectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    if (typeof this.goalId !== 'undefined') {
      toReturn['goalId'] = this.goalId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    return toReturn;
  }
}
class ReplacePrioritiesForProspectRequest {
  static fromProto(proto) {
    let m = new ReplacePrioritiesForProspectRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    if (typeof this.priorityIds !== 'undefined') {
      toReturn['priorityIds'] = this.priorityIds;
    }
    return toReturn;
  }
}
class SetPriorityRequest {
  static fromProto(proto) {
    let m = new SetPriorityRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    return toReturn;
  }
}
class UpsertGoalsForPartnerRequest {
  static fromProto(proto) {
    let m = new UpsertGoalsForPartnerRequest();
    m = Object.assign(m, proto);
    if (proto.goals) {
      m.goals = proto.goals.map(Goal.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.goals !== 'undefined' && this.goals !== null) {
      toReturn['goals'] = 'toApiJson' in this.goals ? this.goals.toApiJson() : this.goals;
    }
    return toReturn;
  }
}
class UpsertPrioritiesForPartnerRequest {
  static fromProto(proto) {
    let m = new UpsertPrioritiesForPartnerRequest();
    m = Object.assign(m, proto);
    if (proto.priorities) {
      m.priorities = proto.priorities.map(Priority.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.priorities !== 'undefined' && this.priorities !== null) {
      toReturn['priorities'] = 'toApiJson' in this.priorities ? this.priorities.toApiJson() : this.priorities;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateTrackerRequest {
  static fromProto(proto) {
    let m = new CreateTrackerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CreateTrackerResponse {
  static fromProto(proto) {
    let m = new CreateTrackerResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetAutomationRequest {
  static fromProto(proto) {
    let m = new GetAutomationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    return toReturn;
  }
}
class GetAutomationResponse {
  static fromProto(proto) {
    let m = new GetAutomationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class Tracker {
  static fromProto(proto) {
    let m = new Tracker();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class UpdateAutomationRequest {
  static fromProto(proto) {
    let m = new UpdateAutomationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    return toReturn;
  }
}
class UpdateAutomationResponse {
  static fromProto(proto) {
    let m = new UpdateAutomationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Address {
  static fromProto(proto) {
    let m = new Address();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addressLineOne !== 'undefined') {
      toReturn['addressLineOne'] = this.addressLineOne;
    }
    if (typeof this.addressLineTwo !== 'undefined') {
      toReturn['addressLineTwo'] = this.addressLineTwo;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    return toReturn;
  }
}
class CreatePartnerAccountRequest {
  static fromProto(proto) {
    let m = new CreatePartnerAccountRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.address) {
      m.address = Address.fromProto(proto.address);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.numberOfEmployees !== 'undefined') {
      toReturn['numberOfEmployees'] = this.numberOfEmployees;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.conversionPoint !== 'undefined') {
      toReturn['conversionPoint'] = this.conversionPoint;
    }
    if (typeof this.prospectPartnerId !== 'undefined') {
      toReturn['prospectPartnerId'] = this.prospectPartnerId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.visitorId !== 'undefined') {
      toReturn['visitorId'] = this.visitorId;
    }
    if (typeof this.otherVisitorIds !== 'undefined') {
      toReturn['otherVisitorIds'] = this.otherVisitorIds;
    }
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.address !== 'undefined' && this.address !== null) {
      toReturn['address'] = 'toApiJson' in this.address ? this.address.toApiJson() : this.address;
    }
    return toReturn;
  }
}
class CreatePartnerAccountResponse {
  static fromProto(proto) {
    let m = new CreatePartnerAccountResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class CustomField {
  static fromProto(proto) {
    let m = new CustomField();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class HandleMarketingFormRequest {
  static fromProto(proto) {
    let m = new HandleMarketingFormRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.numberOfEmployees !== 'undefined') {
      toReturn['numberOfEmployees'] = this.numberOfEmployees;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.localTimeZone !== 'undefined') {
      toReturn['localTimeZone'] = this.localTimeZone;
    }
    if (typeof this.conversionPoint !== 'undefined') {
      toReturn['conversionPoint'] = this.conversionPoint;
    }
    if (typeof this.leadProgram !== 'undefined') {
      toReturn['leadProgram'] = this.leadProgram;
    }
    if (typeof this.leadProgramDescription !== 'undefined') {
      toReturn['leadProgramDescription'] = this.leadProgramDescription;
    }
    if (typeof this.adName !== 'undefined') {
      toReturn['adName'] = this.adName;
    }
    if (typeof this.prospectPartnerId !== 'undefined') {
      toReturn['prospectPartnerId'] = this.prospectPartnerId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.visitorId !== 'undefined') {
      toReturn['visitorId'] = this.visitorId;
    }
    if (typeof this.otherVisitorIds !== 'undefined') {
      toReturn['otherVisitorIds'] = this.otherVisitorIds;
    }
    if (typeof this.affiliateId !== 'undefined') {
      toReturn['affiliateId'] = this.affiliateId;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class ReIgniteOldAccountsRequest {
  static fromProto(proto) {
    let m = new ReIgniteOldAccountsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetUTMAttributesResponse {
  static fromProto(proto) {
    let m = new GetUTMAttributesResponse();
    m = Object.assign(m, proto);
    if (proto.utmAttributes) {
      m.utmAttributes = UTMAttributes.fromProto(proto.utmAttributes);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.utmAttributes !== 'undefined' && this.utmAttributes !== null) {
      toReturn['utmAttributes'] = 'toApiJson' in this.utmAttributes ? this.utmAttributes.toApiJson() : this.utmAttributes;
    }
    return toReturn;
  }
}
class UTMAttributes {
  static fromProto(proto) {
    let m = new UTMAttributes();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.utmCampaign !== 'undefined') {
      toReturn['utmCampaign'] = this.utmCampaign;
    }
    if (typeof this.utmMedium !== 'undefined') {
      toReturn['utmMedium'] = this.utmMedium;
    }
    if (typeof this.utmSource !== 'undefined') {
      toReturn['utmSource'] = this.utmSource;
    }
    if (typeof this.utmContent !== 'undefined') {
      toReturn['utmContent'] = this.utmContent;
    }
    if (typeof this.utmTerm !== 'undefined') {
      toReturn['utmTerm'] = this.utmTerm;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AssociateLeadAndAccountGroupRequest {
  static fromProto(proto) {
    let m = new AssociateLeadAndAccountGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadId !== 'undefined') {
      toReturn['leadId'] = this.leadId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class Business {
  static fromProto(proto) {
    let m = new Business();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    return toReturn;
  }
}
class CreateAccountGroupFromLeadRequest {
  static fromProto(proto) {
    let m = new CreateAccountGroupFromLeadRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadId !== 'undefined') {
      toReturn['leadId'] = this.leadId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class CreateAccountGroupFromLeadResponse {
  static fromProto(proto) {
    let m = new CreateAccountGroupFromLeadResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetLeadQualificationSettingsRequest {
  static fromProto(proto) {
    let m = new GetLeadQualificationSettingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetLeadQualificationSettingsResponse {
  static fromProto(proto) {
    let m = new GetLeadQualificationSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.leadQualificationSettings) {
      m.leadQualificationSettings = LeadQualificationSettings.fromProto(proto.leadQualificationSettings);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.leadQualificationSettings !== 'undefined' && this.leadQualificationSettings !== null) {
      toReturn['leadQualificationSettings'] = 'toApiJson' in this.leadQualificationSettings ? this.leadQualificationSettings.toApiJson() : this.leadQualificationSettings;
    }
    return toReturn;
  }
}
class GetLeadRequest {
  static fromProto(proto) {
    let m = new GetLeadRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadId !== 'undefined') {
      toReturn['leadId'] = this.leadId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetLeadResponse {
  static fromProto(proto) {
    let m = new GetLeadResponse();
    m = Object.assign(m, proto);
    if (proto.lead) {
      m.lead = Lead.fromProto(proto.lead);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lead !== 'undefined' && this.lead !== null) {
      toReturn['lead'] = 'toApiJson' in this.lead ? this.lead.toApiJson() : this.lead;
    }
    return toReturn;
  }
}
class Lead {
  static fromProto(proto) {
    let m = new Lead();
    m = Object.assign(m, proto);
    if (proto.person) {
      m.person = Person.fromProto(proto.person);
    }
    if (proto.business) {
      m.business = Business.fromProto(proto.business);
    }
    if (proto.opportunity) {
      m.opportunity = Opportunity.fromProto(proto.opportunity);
    }
    if (proto.createdTime) {
      m.createdTime = new Date(proto.createdTime);
    }
    if (proto.deletedTime) {
      m.deletedTime = new Date(proto.deletedTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.leadId !== 'undefined') {
      toReturn['leadId'] = this.leadId;
    }
    if (typeof this.person !== 'undefined' && this.person !== null) {
      toReturn['person'] = 'toApiJson' in this.person ? this.person.toApiJson() : this.person;
    }
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.opportunity !== 'undefined' && this.opportunity !== null) {
      toReturn['opportunity'] = 'toApiJson' in this.opportunity ? this.opportunity.toApiJson() : this.opportunity;
    }
    if (typeof this.createdTime !== 'undefined' && this.createdTime !== null) {
      toReturn['createdTime'] = 'toApiJson' in this.createdTime ? this.createdTime.toApiJson() : this.createdTime;
    }
    if (typeof this.deletedTime !== 'undefined' && this.deletedTime !== null) {
      toReturn['deletedTime'] = 'toApiJson' in this.deletedTime ? this.deletedTime.toApiJson() : this.deletedTime;
    }
    if (typeof this.campaignName !== 'undefined') {
      toReturn['campaignName'] = this.campaignName;
    }
    if (typeof this.adName !== 'undefined') {
      toReturn['adName'] = this.adName;
    }
    return toReturn;
  }
}
class LeadQualificationSettings {
  static fromProto(proto) {
    let m = new LeadQualificationSettings();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.createAccountGroup !== 'undefined') {
      toReturn['createAccountGroup'] = this.createAccountGroup;
    }
    if (typeof this.logActivityAndReassign !== 'undefined') {
      toReturn['logActivityAndReassign'] = this.logActivityAndReassign;
    }
    return toReturn;
  }
}
class ListAccountGroupsAssociatedToLeadRequest {
  static fromProto(proto) {
    let m = new ListAccountGroupsAssociatedToLeadRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadId !== 'undefined') {
      toReturn['leadId'] = this.leadId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListAccountGroupsAssociatedToLeadResponse {
  static fromProto(proto) {
    let m = new ListAccountGroupsAssociatedToLeadResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    return toReturn;
  }
}
class ListLeadsAssociatedToAccountGroupRequest {
  static fromProto(proto) {
    let m = new ListLeadsAssociatedToAccountGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListLeadsAssociatedToAccountGroupResponse {
  static fromProto(proto) {
    let m = new ListLeadsAssociatedToAccountGroupResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leadIds !== 'undefined') {
      toReturn['leadIds'] = this.leadIds;
    }
    return toReturn;
  }
}
class ListLeadsForPartnerRequest {
  static fromProto(proto) {
    let m = new ListLeadsForPartnerRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.leadQualificationType) {
      m.leadQualificationType = enumStringToValue$6(LeadQualificationType, proto.leadQualificationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.leadQualificationType !== 'undefined') {
      toReturn['leadQualificationType'] = this.leadQualificationType;
    }
    return toReturn;
  }
}
class ListLeadsForPartnerResponse {
  static fromProto(proto) {
    let m = new ListLeadsForPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.leads) {
      m.leads = proto.leads.map(Lead.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.leads !== 'undefined' && this.leads !== null) {
      toReturn['leads'] = 'toApiJson' in this.leads ? this.leads.toApiJson() : this.leads;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Opportunity {
  static fromProto(proto) {
    let m = new Opportunity();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class Person {
  static fromProto(proto) {
    let m = new Person();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    return toReturn;
  }
}
class ReplaceLeadQualificationSettingsRequest {
  static fromProto(proto) {
    let m = new ReplaceLeadQualificationSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.leadQualificationSettings) {
      m.leadQualificationSettings = LeadQualificationSettings.fromProto(proto.leadQualificationSettings);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.leadQualificationSettings !== 'undefined' && this.leadQualificationSettings !== null) {
      toReturn['leadQualificationSettings'] = 'toApiJson' in this.leadQualificationSettings ? this.leadQualificationSettings.toApiJson() : this.leadQualificationSettings;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ConnectLeadsForPageRequest {
  static fromProto(proto) {
    let m = new ConnectLeadsForPageRequest();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$5(LeadSource, proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.pageName !== 'undefined') {
      toReturn['pageName'] = this.pageName;
    }
    return toReturn;
  }
}
class DisconnectLeadsForPageRequest {
  static fromProto(proto) {
    let m = new DisconnectLeadsForPageRequest();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$5(LeadSource, proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    return toReturn;
  }
}
class LeadAdsAutomation {
  static fromProto(proto) {
    let m = new LeadAdsAutomation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.automationStatus !== 'undefined') {
      toReturn['automationStatus'] = this.automationStatus;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    return toReturn;
  }
}
class LeadAdsFormConnectionSettings {
  static fromProto(proto) {
    let m = new LeadAdsFormConnectionSettings();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$5(LeadSource, proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.formId !== 'undefined') {
      toReturn['formId'] = this.formId;
    }
    if (typeof this.enabled !== 'undefined') {
      toReturn['enabled'] = this.enabled;
    }
    if (typeof this.destinationMarketId !== 'undefined') {
      toReturn['destinationMarketId'] = this.destinationMarketId;
    }
    return toReturn;
  }
}
class ListLeadAdsFormConnectionSettingsRequest {
  static fromProto(proto) {
    let m = new ListLeadAdsFormConnectionSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$5(LeadSource, proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    return toReturn;
  }
}
class ListLeadAdsFormConnectionSettingsResponse {
  static fromProto(proto) {
    let m = new ListLeadAdsFormConnectionSettingsResponse();
    m = Object.assign(m, proto);
    if (proto.formAutomations) {
      m.formAutomations = proto.formAutomations.map(LeadAdsFormConnectionSettings.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formAutomations !== 'undefined' && this.formAutomations !== null) {
      toReturn['formAutomations'] = 'toApiJson' in this.formAutomations ? this.formAutomations.toApiJson() : this.formAutomations;
    }
    return toReturn;
  }
}
class ListPartnerLeadAdAutomationsRequest {
  static fromProto(proto) {
    let m = new ListPartnerLeadAdAutomationsRequest();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$5(LeadSource, proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    return toReturn;
  }
}
class ListPartnerLeadAdAutomationsResponse {
  static fromProto(proto) {
    let m = new ListPartnerLeadAdAutomationsResponse();
    m = Object.assign(m, proto);
    if (proto.automations) {
      m.automations = proto.automations.map(LeadAdsAutomation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.automations !== 'undefined' && this.automations !== null) {
      toReturn['automations'] = 'toApiJson' in this.automations ? this.automations.toApiJson() : this.automations;
    }
    return toReturn;
  }
}
class ListPartnersConnectedToPageRequest {
  static fromProto(proto) {
    let m = new ListPartnersConnectedToPageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    return toReturn;
  }
}
class ListPartnersConnectedToPageResponse {
  static fromProto(proto) {
    let m = new ListPartnersConnectedToPageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerIds !== 'undefined') {
      toReturn['partnerIds'] = this.partnerIds;
    }
    return toReturn;
  }
}
class PartnerFacebookLeadAdsConnectionStatusRequest {
  static fromProto(proto) {
    let m = new PartnerFacebookLeadAdsConnectionStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class PartnerFacebookLeadAdsConnectionStatusResponse {
  static fromProto(proto) {
    let m = new PartnerFacebookLeadAdsConnectionStatusResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.hasGrantedAccessToken !== 'undefined') {
      toReturn['hasGrantedAccessToken'] = this.hasGrantedAccessToken;
    }
    if (typeof this.isConnected !== 'undefined') {
      toReturn['isConnected'] = this.isConnected;
    }
    if (typeof this.connectedPageId !== 'undefined') {
      toReturn['connectedPageId'] = this.connectedPageId;
    }
    if (typeof this.connectedPageName !== 'undefined') {
      toReturn['connectedPageName'] = this.connectedPageName;
    }
    if (typeof this.tokenIsValid !== 'undefined') {
      toReturn['tokenIsValid'] = this.tokenIsValid;
    }
    return toReturn;
  }
}
class UpdateLeadAdsAutomationStatusRequest {
  static fromProto(proto) {
    let m = new UpdateLeadAdsAutomationStatusRequest();
    m = Object.assign(m, proto);
    if (proto.source) {
      m.source = enumStringToValue$5(LeadSource, proto.source);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageId !== 'undefined') {
      toReturn['pageId'] = this.pageId;
    }
    if (typeof this.automationStatus !== 'undefined') {
      toReturn['automationStatus'] = this.automationStatus;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    return toReturn;
  }
}
class UpdateLeadAdsFormConnectionSettingsRequest {
  static fromProto(proto) {
    let m = new UpdateLeadAdsFormConnectionSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.formAutomation) {
      m.formAutomation = LeadAdsFormConnectionSettings.fromProto(proto.formAutomation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.formAutomation !== 'undefined' && this.formAutomation !== null) {
      toReturn['formAutomation'] = 'toApiJson' in this.formAutomation ? this.formAutomation.toApiJson() : this.formAutomation;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateDuplicateCriteriaRequest {
  static fromProto(proto) {
    let m = new CreateDuplicateCriteriaRequest();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = DuplicateCriteria.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class DuplicateAccount {
  static fromProto(proto) {
    let m = new DuplicateAccount();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class DuplicateCriteria {
  static fromProto(proto) {
    let m = new DuplicateCriteria();
    m = Object.assign(m, proto);
    if (proto.criteriaMatchType) {
      m.criteriaMatchType = enumStringToValue$4(CriteriaMatchType, proto.criteriaMatchType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.useEmail !== 'undefined') {
      toReturn['useEmail'] = this.useEmail;
    }
    if (typeof this.usePhoneNumber !== 'undefined') {
      toReturn['usePhoneNumber'] = this.usePhoneNumber;
    }
    if (typeof this.criteriaMatchType !== 'undefined') {
      toReturn['criteriaMatchType'] = this.criteriaMatchType;
    }
    return toReturn;
  }
}
class FindDuplicateAccountsRequest {
  static fromProto(proto) {
    let m = new FindDuplicateAccountsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    return toReturn;
  }
}
class FindDuplicateAccountsResponse {
  static fromProto(proto) {
    let m = new FindDuplicateAccountsResponse();
    m = Object.assign(m, proto);
    if (proto.duplicateAccounts) {
      m.duplicateAccounts = proto.duplicateAccounts.map(DuplicateAccount.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountIds !== 'undefined') {
      toReturn['accountIds'] = this.accountIds;
    }
    if (typeof this.hasDuplicateInDifferentMarket !== 'undefined') {
      toReturn['hasDuplicateInDifferentMarket'] = this.hasDuplicateInDifferentMarket;
    }
    if (typeof this.duplicateAccounts !== 'undefined' && this.duplicateAccounts !== null) {
      toReturn['duplicateAccounts'] = 'toApiJson' in this.duplicateAccounts ? this.duplicateAccounts.toApiJson() : this.duplicateAccounts;
    }
    return toReturn;
  }
}
class GetDuplicateCriteriaRequest {
  static fromProto(proto) {
    let m = new GetDuplicateCriteriaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetDuplicateCriteriaResponse {
  static fromProto(proto) {
    let m = new GetDuplicateCriteriaResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = DuplicateCriteria.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class UpdateDuplicateCriteriaRequest {
  static fromProto(proto) {
    let m = new UpdateDuplicateCriteriaRequest();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = DuplicateCriteria.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CollectDataRequest {
  static fromProto(proto) {
    let m = new CollectDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class CollectDataResponse {
  static fromProto(proto) {
    let m = new CollectDataResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.collectDataId !== 'undefined') {
      toReturn['collectDataId'] = this.collectDataId;
    }
    return toReturn;
  }
}
class CompanyGeoInformation {
  static fromProto(proto) {
    let m = new CompanyGeoInformation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.streetNumber !== 'undefined') {
      toReturn['streetNumber'] = this.streetNumber;
    }
    if (typeof this.streetName !== 'undefined') {
      toReturn['streetName'] = this.streetName;
    }
    if (typeof this.subPremise !== 'undefined') {
      toReturn['subPremise'] = this.subPremise;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.stateCode !== 'undefined') {
      toReturn['stateCode'] = this.stateCode;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.lat !== 'undefined') {
      toReturn['lat'] = this.lat;
    }
    if (typeof this.lng !== 'undefined') {
      toReturn['lng'] = this.lng;
    }
    return toReturn;
  }
}
class CompanyInformation {
  static fromProto(proto) {
    let m = new CompanyInformation();
    m = Object.assign(m, proto);
    if (proto.metrics) {
      m.metrics = CompanyMetrics.fromProto(proto.metrics);
    }
    if (proto.companySite) {
      m.companySite = CompanySite.fromProto(proto.companySite);
    }
    if (proto.geoInformation) {
      m.geoInformation = CompanyGeoInformation.fromProto(proto.geoInformation);
    }
    if (proto.socialNetworkInformation) {
      m.socialNetworkInformation = SocialNetworkInformation.fromProto(proto.socialNetworkInformation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.metrics !== 'undefined' && this.metrics !== null) {
      toReturn['metrics'] = 'toApiJson' in this.metrics ? this.metrics.toApiJson() : this.metrics;
    }
    if (typeof this.companySite !== 'undefined' && this.companySite !== null) {
      toReturn['companySite'] = 'toApiJson' in this.companySite ? this.companySite.toApiJson() : this.companySite;
    }
    if (typeof this.geoInformation !== 'undefined' && this.geoInformation !== null) {
      toReturn['geoInformation'] = 'toApiJson' in this.geoInformation ? this.geoInformation.toApiJson() : this.geoInformation;
    }
    if (typeof this.socialNetworkInformation !== 'undefined' && this.socialNetworkInformation !== null) {
      toReturn['socialNetworkInformation'] = 'toApiJson' in this.socialNetworkInformation ? this.socialNetworkInformation.toApiJson() : this.socialNetworkInformation;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    return toReturn;
  }
}
class CompanyMetrics {
  static fromProto(proto) {
    let m = new CompanyMetrics();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.employees !== 'undefined') {
      toReturn['employees'] = this.employees;
    }
    if (typeof this.employeesRange !== 'undefined') {
      toReturn['employeesRange'] = this.employeesRange;
    }
    return toReturn;
  }
}
class CompanySite {
  static fromProto(proto) {
    let m = new CompanySite();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    return toReturn;
  }
}
class Employment {
  static fromProto(proto) {
    let m = new Employment();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    return toReturn;
  }
}
class GetAccountGroupSignUpDataRequest {
  static fromProto(proto) {
    let m = new GetAccountGroupSignUpDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetAccountGroupSignUpDataResponse {
  static fromProto(proto) {
    let m = new GetAccountGroupSignUpDataResponse();
    m = Object.assign(m, proto);
    if (proto.person) {
      m.person = PersonInformation.fromProto(proto.person);
    }
    if (proto.company) {
      m.company = CompanyInformation.fromProto(proto.company);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.person !== 'undefined' && this.person !== null) {
      toReturn['person'] = 'toApiJson' in this.person ? this.person.toApiJson() : this.person;
    }
    if (typeof this.company !== 'undefined' && this.company !== null) {
      toReturn['company'] = 'toApiJson' in this.company ? this.company.toApiJson() : this.company;
    }
    return toReturn;
  }
}
class GetDataProviderInfoRequest {
  static fromProto(proto) {
    let m = new GetDataProviderInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class GetDataProviderInfoResponse {
  static fromProto(proto) {
    let m = new GetDataProviderInfoResponse();
    m = Object.assign(m, proto);
    if (proto.person) {
      m.person = PersonInformation.fromProto(proto.person);
    }
    if (proto.company) {
      m.company = CompanyInformation.fromProto(proto.company);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.person !== 'undefined' && this.person !== null) {
      toReturn['person'] = 'toApiJson' in this.person ? this.person.toApiJson() : this.person;
    }
    if (typeof this.company !== 'undefined' && this.company !== null) {
      toReturn['company'] = 'toApiJson' in this.company ? this.company.toApiJson() : this.company;
    }
    return toReturn;
  }
}
class GetPartnerCollectedSignUpDataRequest {
  static fromProto(proto) {
    let m = new GetPartnerCollectedSignUpDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetPartnerCollectedSignUpDataResponse {
  static fromProto(proto) {
    let m = new GetPartnerCollectedSignUpDataResponse();
    m = Object.assign(m, proto);
    if (proto.person) {
      m.person = PersonInformation.fromProto(proto.person);
    }
    if (proto.company) {
      m.company = CompanyInformation.fromProto(proto.company);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.person !== 'undefined' && this.person !== null) {
      toReturn['person'] = 'toApiJson' in this.person ? this.person.toApiJson() : this.person;
    }
    if (typeof this.company !== 'undefined' && this.company !== null) {
      toReturn['company'] = 'toApiJson' in this.company ? this.company.toApiJson() : this.company;
    }
    return toReturn;
  }
}
class PersonInformation {
  static fromProto(proto) {
    let m = new PersonInformation();
    m = Object.assign(m, proto);
    if (proto.name) {
      m.name = PersonName.fromProto(proto.name);
    }
    if (proto.socialNetworkInformation) {
      m.socialNetworkInformation = SocialNetworkInformation.fromProto(proto.socialNetworkInformation);
    }
    if (proto.employment) {
      m.employment = Employment.fromProto(proto.employment);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined' && this.name !== null) {
      toReturn['name'] = 'toApiJson' in this.name ? this.name.toApiJson() : this.name;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.socialNetworkInformation !== 'undefined' && this.socialNetworkInformation !== null) {
      toReturn['socialNetworkInformation'] = 'toApiJson' in this.socialNetworkInformation ? this.socialNetworkInformation.toApiJson() : this.socialNetworkInformation;
    }
    if (typeof this.employment !== 'undefined' && this.employment !== null) {
      toReturn['employment'] = 'toApiJson' in this.employment ? this.employment.toApiJson() : this.employment;
    }
    return toReturn;
  }
}
class PersonName {
  static fromProto(proto) {
    let m = new PersonName();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    if (typeof this.givenName !== 'undefined') {
      toReturn['givenName'] = this.givenName;
    }
    if (typeof this.familyName !== 'undefined') {
      toReturn['familyName'] = this.familyName;
    }
    return toReturn;
  }
}
class SocialNetworkInformation {
  static fromProto(proto) {
    let m = new SocialNetworkInformation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.linkedinHandle !== 'undefined') {
      toReturn['linkedinHandle'] = this.linkedinHandle;
    }
    if (typeof this.facebookHandle !== 'undefined') {
      toReturn['facebookHandle'] = this.facebookHandle;
    }
    if (typeof this.twitterHandle !== 'undefined') {
      toReturn['twitterHandle'] = this.twitterHandle;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CheckDisposableEmailRequest {
  static fromProto(proto) {
    let m = new CheckDisposableEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class CheckDisposableEmailResponse {
  static fromProto(proto) {
    let m = new CheckDisposableEmailResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isDisposable !== 'undefined') {
      toReturn['isDisposable'] = this.isDisposable;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetUTMAttributesRequest {
  static fromProto(proto) {
    let m = new GetUTMAttributesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospectId !== 'undefined') {
      toReturn['prospectId'] = this.prospectId;
    }
    return toReturn;
  }
}
class ListPartnerProspectsRequest {
  static fromProto(proto) {
    let m = new ListPartnerProspectsRequest();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedRequestOptions.fromProto(proto.paging);
    }
    if (proto.dateRange) {
      m.dateRange = enumStringToValue(DateRange, proto.dateRange);
    }
    if (proto.filters) {
      m.filters = Filters.fromProto(proto.filters);
    }
    if (proto.multiSortingOptions) {
      m.multiSortingOptions = MultiSortingOptions.fromProto(proto.multiSortingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.dateRange !== 'undefined') {
      toReturn['dateRange'] = this.dateRange;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.multiSortingOptions !== 'undefined' && this.multiSortingOptions !== null) {
      toReturn['multiSortingOptions'] = 'toApiJson' in this.multiSortingOptions ? this.multiSortingOptions.toApiJson() : this.multiSortingOptions;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'prospect-api.vendasta-local.com',
  'test': '',
  'demo': 'prospect-api-demo.apigateway.co',
  'prod': 'prospect-api-prod.apigateway.co',
  'production': 'prospect-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AccountAnalyticsApiService = /*#__PURE__*/(() => {
  class AccountAnalyticsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListAccountAnalyticsRequest(r);
      return this.http.post(this._host + "/prospect.v1.AccountAnalytics/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAccountAnalyticsResponse.fromProto(resp)));
    }
  }
  AccountAnalyticsApiService.ɵfac = function AccountAnalyticsApiService_Factory(t) {
    return new (t || AccountAnalyticsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AccountAnalyticsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountAnalyticsApiService,
    factory: AccountAnalyticsApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountAnalyticsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AffiliatesApiService = /*#__PURE__*/(() => {
  class AffiliatesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listAffiliates(r) {
      const request = r.toApiJson ? r : new ListAffiliatesRequest(r);
      return this.http.post(this._host + "/prospect.v1.Affiliates/ListAffiliates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAffiliatesResponse.fromProto(resp)));
    }
    createAffiliate(r) {
      const request = r.toApiJson ? r : new CreateAffiliateRequest(r);
      return this.http.post(this._host + "/prospect.v1.Affiliates/CreateAffiliate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAffiliateResponse.fromProto(resp)));
    }
    getAffiliate(r) {
      const request = r.toApiJson ? r : new GetAffiliateRequest(r);
      return this.http.post(this._host + "/prospect.v1.Affiliates/GetAffiliate", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAffiliateResponse.fromProto(resp)));
    }
    updateAffiliateStatus(r) {
      const request = r.toApiJson ? r : new UpdateAffiliateStatusRequest(r);
      return this.http.post(this._host + "/prospect.v1.Affiliates/UpdateAffiliateStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateAffiliateStatusResponse.fromProto(resp)));
    }
    putAffiliatePaymentAmounts(r) {
      const request = r.toApiJson ? r : new PutAffiliatePaymentAmountsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Affiliates/PutAffiliatePaymentAmounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => PutAffiliatePaymentAmountsResponse.fromProto(resp)));
    }
    getAffiliatePaymentAmounts(r) {
      const request = r.toApiJson ? r : new GetAffiliatePaymentAmountsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Affiliates/GetAffiliatePaymentAmounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAffiliatePaymentAmountsResponse.fromProto(resp)));
    }
    createTermsOfService(r) {
      const request = r.toApiJson ? r : new CreateTermsOfServiceRequest(r);
      return this.http.post(this._host + "/prospect.v1.Affiliates/CreateTermsOfService", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTermsOfServiceResponse.fromProto(resp)));
    }
    getTermsOfService(r) {
      const request = r.toApiJson ? r : new GetTermsOfServiceRequest(r);
      return this.http.post(this._host + "/prospect.v1.Affiliates/GetTermsOfService", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetTermsOfServiceResponse.fromProto(resp)));
    }
    getAffiliatePaymentReport(r) {
      const request = r.toApiJson ? r : new GetAffiliatePaymentReportRequest(r);
      return this.http.post(this._host + "/prospect.v1.Affiliates/GetAffiliatePaymentReport", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAffiliatePaymentReportResponse.fromProto(resp)));
    }
  }
  AffiliatesApiService.ɵfac = function AffiliatesApiService_Factory(t) {
    return new (t || AffiliatesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AffiliatesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AffiliatesApiService,
    factory: AffiliatesApiService.ɵfac,
    providedIn: 'root'
  });
  return AffiliatesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AnalyticsPresetViewsApiService = /*#__PURE__*/(() => {
  class AnalyticsPresetViewsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListAnalyticsPresetViewRequest(r);
      return this.http.post(this._host + "/prospect.v1.AnalyticsPresetViews/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAnalyticsPresetViewResponse.fromProto(resp)));
    }
    put(r) {
      const request = r.toApiJson ? r : new AnalyticsPresetView(r);
      return this.http.post(this._host + "/prospect.v1.AnalyticsPresetViews/Put", request.toApiJson(), this.apiOptions()).pipe(map(resp => PutAnalyticsPresetViewResponse.fromProto(resp)));
    }
  }
  AnalyticsPresetViewsApiService.ɵfac = function AnalyticsPresetViewsApiService_Factory(t) {
    return new (t || AnalyticsPresetViewsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AnalyticsPresetViewsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AnalyticsPresetViewsApiService,
    factory: AnalyticsPresetViewsApiService.ɵfac,
    providedIn: 'root'
  });
  return AnalyticsPresetViewsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let CampaignApiService = /*#__PURE__*/(() => {
  class CampaignApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    initiateCampaignHistoryExport(r) {
      const request = r.toApiJson ? r : new InitiateCampaignHistoryExportRequest(r);
      return this.http.post(this._host + "/prospect.v1.Campaign/InitiateCampaignHistoryExport", request.toApiJson(), this.apiOptions()).pipe(map(resp => InitiateCampaignHistoryExportResponse.fromProto(resp)));
    }
  }
  CampaignApiService.ɵfac = function CampaignApiService_Factory(t) {
    return new (t || CampaignApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CampaignApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignApiService,
    factory: CampaignApiService.ɵfac,
    providedIn: 'root'
  });
  return CampaignApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let DisposableEmailApiService = /*#__PURE__*/(() => {
  class DisposableEmailApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    checkDisposableEmail(r) {
      const request = r.toApiJson ? r : new CheckDisposableEmailRequest(r);
      return this.http.post(this._host + "/prospect.v1.DisposableEmail/CheckDisposableEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => CheckDisposableEmailResponse.fromProto(resp)));
    }
  }
  DisposableEmailApiService.ɵfac = function DisposableEmailApiService_Factory(t) {
    return new (t || DisposableEmailApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  DisposableEmailApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DisposableEmailApiService,
    factory: DisposableEmailApiService.ɵfac,
    providedIn: 'root'
  });
  return DisposableEmailApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let LeadsApiService = /*#__PURE__*/(() => {
  class LeadsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    partnerFacebookLeadAdsConnectionStatus(r) {
      const request = r.toApiJson ? r : new PartnerFacebookLeadAdsConnectionStatusRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/PartnerFacebookLeadAdsConnectionStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => PartnerFacebookLeadAdsConnectionStatusResponse.fromProto(resp)));
    }
    listLeadAdsFormsConnectionSettings(r) {
      const request = r.toApiJson ? r : new ListLeadAdsFormConnectionSettingsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/ListLeadAdsFormsConnectionSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListLeadAdsFormConnectionSettingsResponse.fromProto(resp)));
    }
    updateLeadAdsFormConnectionSettings(r) {
      const request = r.toApiJson ? r : new UpdateLeadAdsFormConnectionSettingsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/UpdateLeadAdsFormConnectionSettings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    connectLeadsForPage(r) {
      const request = r.toApiJson ? r : new ConnectLeadsForPageRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/ConnectLeadsForPage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    disconnectLeadsForPage(r) {
      const request = r.toApiJson ? r : new DisconnectLeadsForPageRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/DisconnectLeadsForPage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listPartnerLeadAdsAutomations(r) {
      const request = r.toApiJson ? r : new ListPartnerLeadAdAutomationsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/ListPartnerLeadAdsAutomations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPartnerLeadAdAutomationsResponse.fromProto(resp)));
    }
    updateLeadAdsAutomationStatus(r) {
      const request = r.toApiJson ? r : new UpdateLeadAdsAutomationStatusRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/UpdateLeadAdsAutomationStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createAccountGroupFromLead(r) {
      const request = r.toApiJson ? r : new CreateAccountGroupFromLeadRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/CreateAccountGroupFromLead", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAccountGroupFromLeadResponse.fromProto(resp)));
    }
    listLeadsForPartner(r) {
      const request = r.toApiJson ? r : new ListLeadsForPartnerRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/ListLeadsForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListLeadsForPartnerResponse.fromProto(resp)));
    }
    getLead(r) {
      const request = r.toApiJson ? r : new GetLeadRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/GetLead", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLeadResponse.fromProto(resp)));
    }
    associateLeadAndAccountGroup(r) {
      const request = r.toApiJson ? r : new AssociateLeadAndAccountGroupRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/AssociateLeadAndAccountGroup", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listLeadsAssociatedToAccountGroup(r) {
      const request = r.toApiJson ? r : new ListLeadsAssociatedToAccountGroupRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/ListLeadsAssociatedToAccountGroup", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListLeadsAssociatedToAccountGroupResponse.fromProto(resp)));
    }
    listAccountGroupsAssociatedToLead(r) {
      const request = r.toApiJson ? r : new ListAccountGroupsAssociatedToLeadRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/ListAccountGroupsAssociatedToLead", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAccountGroupsAssociatedToLeadResponse.fromProto(resp)));
    }
    getLeadQualificationSettings(r) {
      const request = r.toApiJson ? r : new GetLeadQualificationSettingsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/GetLeadQualificationSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLeadQualificationSettingsResponse.fromProto(resp)));
    }
    replaceLeadQualificationSettings(r) {
      const request = r.toApiJson ? r : new ReplaceLeadQualificationSettingsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/ReplaceLeadQualificationSettings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listPartnersConnectedToPage(r) {
      const request = r.toApiJson ? r : new ListPartnersConnectedToPageRequest(r);
      return this.http.post(this._host + "/prospect.v1.Leads/ListPartnersConnectedToPage", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPartnersConnectedToPageResponse.fromProto(resp)));
    }
  }
  LeadsApiService.ɵfac = function LeadsApiService_Factory(t) {
    return new (t || LeadsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  LeadsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LeadsApiService,
    factory: LeadsApiService.ɵfac,
    providedIn: 'root'
  });
  return LeadsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let MarketingAutomationApiService = /*#__PURE__*/(() => {
  class MarketingAutomationApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createTracker(r) {
      const request = r.toApiJson ? r : new CreateTrackerRequest(r);
      return this.http.post(this._host + "/prospect.v1.MarketingAutomation/CreateTracker", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateTrackerResponse.fromProto(resp)));
    }
    updateAutomation(r) {
      const request = r.toApiJson ? r : new UpdateAutomationRequest(r);
      return this.http.post(this._host + "/prospect.v1.MarketingAutomation/UpdateAutomation", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateAutomationResponse.fromProto(resp)));
    }
    getAutomation(r) {
      const request = r.toApiJson ? r : new GetAutomationRequest(r);
      return this.http.post(this._host + "/prospect.v1.MarketingAutomation/GetAutomation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAutomationResponse.fromProto(resp)));
    }
  }
  MarketingAutomationApiService.ɵfac = function MarketingAutomationApiService_Factory(t) {
    return new (t || MarketingAutomationApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  MarketingAutomationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MarketingAutomationApiService,
    factory: MarketingAutomationApiService.ɵfac,
    providedIn: 'root'
  });
  return MarketingAutomationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let MarketingFormsApiService = /*#__PURE__*/(() => {
  class MarketingFormsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    handleMarketingForm(r) {
      const request = r.toApiJson ? r : new HandleMarketingFormRequest(r);
      return this.http.post(this._host + "/prospect.v1.MarketingForms/HandleMarketingForm", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createPartnerAccount(r) {
      const request = r.toApiJson ? r : new CreatePartnerAccountRequest(r);
      return this.http.post(this._host + "/prospect.v1.MarketingForms/CreatePartnerAccount", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreatePartnerAccountResponse.fromProto(resp)));
    }
    reIgniteOldAccounts(r) {
      const request = r.toApiJson ? r : new ReIgniteOldAccountsRequest(r);
      return this.http.post(this._host + "/prospect.v1.MarketingForms/ReIgniteOldAccounts", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  MarketingFormsApiService.ɵfac = function MarketingFormsApiService_Factory(t) {
    return new (t || MarketingFormsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  MarketingFormsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MarketingFormsApiService,
    factory: MarketingFormsApiService.ɵfac,
    providedIn: 'root'
  });
  return MarketingFormsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let OnboardingStrategiesApiService = /*#__PURE__*/(() => {
  class OnboardingStrategiesApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsertGoalsForPartner(r) {
      const request = r.toApiJson ? r : new UpsertGoalsForPartnerRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/UpsertGoalsForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGoalsForPartnerResponse.fromProto(resp)));
    }
    deleteGoalsFromPartner(r) {
      const request = r.toApiJson ? r : new DeleteGoalsFromPartnerRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/DeleteGoalsFromPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGoalsForPartnerResponse.fromProto(resp)));
    }
    listGoalsForPartner(r) {
      const request = r.toApiJson ? r : new ListGoalsForPartnerRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/ListGoalsForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListGoalsForPartnerResponse.fromProto(resp)));
    }
    replaceGoalForProspect(r) {
      const request = r.toApiJson ? r : new ReplaceGoalForProspectRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/ReplaceGoalForProspect", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getGoalForProspect(r) {
      const request = r.toApiJson ? r : new GetGoalForProspectRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/GetGoalForProspect", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetGoalForProspectResponse.fromProto(resp)));
    }
    upsertPrioritiesForPartner(r) {
      const request = r.toApiJson ? r : new UpsertPrioritiesForPartnerRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/UpsertPrioritiesForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPrioritiesForPartnerResponse.fromProto(resp)));
    }
    deletePrioritiesFromPartner(r) {
      const request = r.toApiJson ? r : new DeletePrioritiesFromPartnerRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/DeletePrioritiesFromPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPrioritiesForPartnerResponse.fromProto(resp)));
    }
    listPrioritiesForPartner(r) {
      const request = r.toApiJson ? r : new ListPrioritiesForPartnerRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/ListPrioritiesForPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPrioritiesForPartnerResponse.fromProto(resp)));
    }
    addPriorityToProspect(r) {
      const request = r.toApiJson ? r : new AddPriorityToProspectRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/AddPriorityToProspect", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPrioritiesForProspectResponse.fromProto(resp)));
    }
    replacePrioritiesForProspect(r) {
      const request = r.toApiJson ? r : new ReplacePrioritiesForProspectRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/ReplacePrioritiesForProspect", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listPrioritiesForProspect(r) {
      const request = r.toApiJson ? r : new ListPrioritiesForProspectRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/ListPrioritiesForProspect", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPrioritiesForProspectResponse.fromProto(resp)));
    }
    removePriorityFromProspect(r) {
      const request = r.toApiJson ? r : new RemovePriorityFromProspectRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/RemovePriorityFromProspect", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPrioritiesForProspectResponse.fromProto(resp)));
    }
    replaceEarlyWinForProspect(r) {
      const request = r.toApiJson ? r : new ReplaceEarlyWinForProspectRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/ReplaceEarlyWinForProspect", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getEarlyWinForProspect(r) {
      const request = r.toApiJson ? r : new GetEarlyWinForProspectRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/GetEarlyWinForProspect", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEarlyWinForProspectResponse.fromProto(resp)));
    }
    getPriority(r) {
      const request = r.toApiJson ? r : new GetPriorityRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/GetPriority", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPriorityResponse.fromProto(resp)));
    }
    setPriority(r) {
      const request = r.toApiJson ? r : new SetPriorityRequest(r);
      return this.http.post(this._host + "/prospect.v1.OnboardingStrategies/SetPriority", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  OnboardingStrategiesApiService.ɵfac = function OnboardingStrategiesApiService_Factory(t) {
    return new (t || OnboardingStrategiesApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  OnboardingStrategiesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: OnboardingStrategiesApiService,
    factory: OnboardingStrategiesApiService.ɵfac,
    providedIn: 'root'
  });
  return OnboardingStrategiesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let PartnerApiService = /*#__PURE__*/(() => {
  class PartnerApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listPartnerProspects(r) {
      const request = r.toApiJson ? r : new ListPartnerProspectsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Partner/ListPartnerProspects", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPartnerProspectsResponse.fromProto(resp)));
    }
    findDuplicatePartnerProspects(r) {
      const request = r.toApiJson ? r : new FindDuplicatePartnerProspectsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Partner/FindDuplicatePartnerProspects", request.toApiJson(), this.apiOptions()).pipe(map(resp => FindDuplicatePartnerProspectsResponse.fromProto(resp)));
    }
    backfillLeadAttributionForBusiness(r) {
      const request = r.toApiJson ? r : new BackfillLeadAttributionForBusinessRequest(r);
      return this.http.post(this._host + "/prospect.v1.Partner/BackfillLeadAttributionForBusiness", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  PartnerApiService.ɵfac = function PartnerApiService_Factory(t) {
    return new (t || PartnerApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  PartnerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerApiService,
    factory: PartnerApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ProspectApiService = /*#__PURE__*/(() => {
  class ProspectApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getUtmAttributes(r) {
      const request = r.toApiJson ? r : new GetUTMAttributesRequest(r);
      return this.http.post(this._host + "/prospect.v1.Prospect/GetUTMAttributes", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUTMAttributesResponse.fromProto(resp)));
    }
    findDuplicateAccounts(r) {
      const request = r.toApiJson ? r : new FindDuplicateAccountsRequest(r);
      return this.http.post(this._host + "/prospect.v1.Prospect/FindDuplicateAccounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => FindDuplicateAccountsResponse.fromProto(resp)));
    }
    createDuplicateCriteria(r) {
      const request = r.toApiJson ? r : new CreateDuplicateCriteriaRequest(r);
      return this.http.post(this._host + "/prospect.v1.Prospect/CreateDuplicateCriteria", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getDuplicateCriteria(r) {
      const request = r.toApiJson ? r : new GetDuplicateCriteriaRequest(r);
      return this.http.post(this._host + "/prospect.v1.Prospect/GetDuplicateCriteria", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDuplicateCriteriaResponse.fromProto(resp)));
    }
    updateDuplicateCriteria(r) {
      const request = r.toApiJson ? r : new UpdateDuplicateCriteriaRequest(r);
      return this.http.post(this._host + "/prospect.v1.Prospect/UpdateDuplicateCriteria", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ProspectApiService.ɵfac = function ProspectApiService_Factory(t) {
    return new (t || ProspectApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ProspectApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProspectApiService,
    factory: ProspectApiService.ɵfac,
    providedIn: 'root'
  });
  return ProspectApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let SignUpDataCollectionApiService = /*#__PURE__*/(() => {
  class SignUpDataCollectionApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getDataProviderInfo(r) {
      const request = r.toApiJson ? r : new GetDataProviderInfoRequest(r);
      return this.http.post(this._host + "/prospect.v1.SignUpDataCollection/GetDataProviderInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDataProviderInfoResponse.fromProto(resp)));
    }
    collectData(r) {
      const request = r.toApiJson ? r : new CollectDataRequest(r);
      return this.http.post(this._host + "/prospect.v1.SignUpDataCollection/CollectData", request.toApiJson(), this.apiOptions()).pipe(map(resp => CollectDataResponse.fromProto(resp)));
    }
    getAccountGroupSignUpData(r) {
      const request = r.toApiJson ? r : new GetAccountGroupSignUpDataRequest(r);
      return this.http.post(this._host + "/prospect.v1.SignUpDataCollection/GetAccountGroupSignUpData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountGroupSignUpDataResponse.fromProto(resp)));
    }
    getPartnerCollectedSignUpData(r) {
      const request = r.toApiJson ? r : new GetPartnerCollectedSignUpDataRequest(r);
      return this.http.post(this._host + "/prospect.v1.SignUpDataCollection/GetPartnerCollectedSignUpData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPartnerCollectedSignUpDataResponse.fromProto(resp)));
    }
  }
  SignUpDataCollectionApiService.ɵfac = function SignUpDataCollectionApiService_Factory(t) {
    return new (t || SignUpDataCollectionApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  SignUpDataCollectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SignUpDataCollectionApiService,
    factory: SignUpDataCollectionApiService.ɵfac,
    providedIn: 'root'
  });
  return SignUpDataCollectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

// *********************************
let CampaignService = /*#__PURE__*/(() => {
  class CampaignService {
    constructor(_api) {
      this._api = _api;
    }
    initiateCampaignHistoryExport(campaignId, partnerId, marketId, campaignStepIds, eventTypes, sortBy, sortOrder, uniqueEngagementOnly) {
      const campaignEventTypes = convertEventTypesToCampaignEventTypes(eventTypes);
      const campaignSortOrder = convertSortOrderToCampaignSortOrder(sortOrder);
      const campaignSortBy = convertSortedByToCampaignSortedBy(sortBy);
      return this._api.initiateCampaignHistoryExport({
        campaignId: campaignId,
        partnerId: partnerId,
        marketId: marketId,
        campaignStepIds: campaignStepIds,
        eventTypes: campaignEventTypes,
        sortBy: campaignSortBy,
        orderBy: campaignSortOrder,
        uniqueEngagementOnly: uniqueEngagementOnly
      }).pipe(map(resp => resp.exportId));
    }
  }
  CampaignService.ɵfac = function CampaignService_Factory(t) {
    return new (t || CampaignService)(i0.ɵɵinject(CampaignApiService));
  };
  CampaignService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CampaignService,
    factory: CampaignService.ɵfac,
    providedIn: 'root'
  });
  return CampaignService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
// converts the string SortOrder filter to the expect campaign API format
function convertSortedByToCampaignSortedBy(fieldName) {
  if (fieldName === 'event_date') {
    return InitiateCampaignHistoryExportRequestSortBy.INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_SORT_BY_EVENT_DATE;
  }
  return InitiateCampaignHistoryExportRequestSortBy.INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_SORT_BY_EVENT_DATE;
}
// converts the string SortOrder filter to the expect campaign API format
function convertSortOrderToCampaignSortOrder(order) {
  if (order === 1) {
    return InitiateCampaignHistoryExportRequestOrderBy.INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_ORDER_BY_ASC;
  }
  return InitiateCampaignHistoryExportRequestOrderBy.INITIATE_CAMPAIGN_HISTORY_EXPORT_REQUEST_ORDER_BY_DESC;
}
// converts the string representations of event type filters to the campaign event type API format
function convertEventTypesToCampaignEventTypes(eventTypes) {
  const campaignEventType = [];
  for (const eventType of eventTypes) {
    if (eventType === 'spamreport') {
      campaignEventType.push(CampaignEventType.CAMPAIGN_EVENT_TYPE_SPAM_REPORT);
    } else if (eventType === 'delivered') {
      campaignEventType.push(CampaignEventType.CAMPAIGN_EVENT_TYPE_DELIVERED);
    } else if (eventType === 'processed') {
      campaignEventType.push(CampaignEventType.CAMPAIGN_EVENT_TYPE_PROCESSED);
    } else if (eventType === 'click') {
      campaignEventType.push(CampaignEventType.CAMPAIGN_EVENT_TYPE_CLICK);
    } else if (eventType === 'open') {
      campaignEventType.push(CampaignEventType.CAMPAIGN_EVENT_TYPE_OPEN);
    } else if (eventType === 'bounce') {
      campaignEventType.push(CampaignEventType.CAMPAIGN_EVENT_TYPE_BOUNCE);
    } else if (eventType === 'unsubscribe') {
      campaignEventType.push(CampaignEventType.CAMPAIGN_EVENT_TYPE_UNSUBSCRIBE);
    } else if (eventType === 'dropped') {
      campaignEventType.push(CampaignEventType.CAMPAIGN_EVENT_TYPE_DROPPED);
    }
  }
  return campaignEventType;
}

// MANUALLY CREATED FILE

/**
 * Generated bundle index. Do not edit.
 */

export { Access, Account, AccountAnalyticsApiService, AccountAttributeFilters, AccountAttributes, AccountFilters, AccountMetrics, AccountsCreatedRange, AddPriorityToProspectRequest, Address, Affiliate, AffiliatePaymentAmounts, AffiliatePaymentReportLineItem, AffiliatesApiService, AnalyticsPresetView, AnalyticsPresetViewsApiService, ArchivedFilter, AssociateLeadAndAccountGroupRequest, AttributeFilters, Attributes, BackfillLeadAttributionForBusinessRequest, BilledClientsRange, BooleanFilter, Business, CampaignApiService, CampaignEventType, CampaignService, CheckDisposableEmailRequest, CheckDisposableEmailResponse, CollectDataRequest, CollectDataResponse, CompanyGeoInformation, CompanyInformation, CompanyMetrics, CompanySite, ConnectLeadsForPageRequest, ContractStatus, CreateAccountGroupFromLeadRequest, CreateAccountGroupFromLeadResponse, CreateAffiliateRequest, CreateAffiliateResponse, CreateDuplicateCriteriaRequest, CreatePartnerAccountRequest, CreatePartnerAccountResponse, CreateTermsOfServiceRequest, CreateTermsOfServiceResponse, CreateTrackerRequest, CreateTrackerResponse, CriteriaMatchType, CustomField, DateRange, DeleteGoalsFromPartnerRequest, DeletePrioritiesFromPartnerRequest, DisconnectLeadsForPageRequest, DisposableEmailApiService, DuplicateAccount, DuplicateCriteria, EarlyWin, EmailType, Employment, ExportToCSVRequest, Filters, FindDuplicateAccountsRequest, FindDuplicateAccountsResponse, FindDuplicatePartnerProspectsRequest, FindDuplicatePartnerProspectsResponse, GetAccountGroupSignUpDataRequest, GetAccountGroupSignUpDataResponse, GetAffiliatePaymentAmountsRequest, GetAffiliatePaymentAmountsResponse, GetAffiliatePaymentReportRequest, GetAffiliatePaymentReportResponse, GetAffiliateRequest, GetAffiliateResponse, GetAutomationRequest, GetAutomationResponse, GetDataProviderInfoRequest, GetDataProviderInfoResponse, GetDuplicateCriteriaRequest, GetDuplicateCriteriaResponse, GetEarlyWinForProspectRequest, GetEarlyWinForProspectResponse, GetGoalForProspectRequest, GetGoalForProspectResponse, GetLeadQualificationSettingsRequest, GetLeadQualificationSettingsResponse, GetLeadRequest, GetLeadResponse, GetPartnerCollectedSignUpDataRequest, GetPartnerCollectedSignUpDataResponse, GetPriorityRequest, GetPriorityResponse, GetTermsOfServiceRequest, GetTermsOfServiceResponse, GetUTMAttributesRequest, GetUTMAttributesResponse, Goal, HandleMarketingFormRequest, HasPidFilter, HostService, InitiateCampaignHistoryExportRequest, InitiateCampaignHistoryExportRequestOrderBy, InitiateCampaignHistoryExportRequestSortBy, InitiateCampaignHistoryExportResponse, LatestSalesActivityOption, Lead, LeadAdsAutomation, LeadAdsFormConnectionSettings, LeadQualificationSettings, LeadQualificationType, LeadSource, LeadsApiService, ListAccountAnalyticsRequest, ListAccountAnalyticsResponse, ListAccountGroupsAssociatedToLeadRequest, ListAccountGroupsAssociatedToLeadResponse, ListAffiliatesRequest, ListAffiliatesResponse, ListAnalyticsPresetViewRequest, ListAnalyticsPresetViewResponse, ListGoalsForPartnerRequest, ListGoalsForPartnerResponse, ListLeadAdsFormConnectionSettingsRequest, ListLeadAdsFormConnectionSettingsResponse, ListLeadsAssociatedToAccountGroupRequest, ListLeadsAssociatedToAccountGroupResponse, ListLeadsForPartnerRequest, ListLeadsForPartnerResponse, ListPartnerLeadAdAutomationsRequest, ListPartnerLeadAdAutomationsResponse, ListPartnerProspectsRequest, ListPartnerProspectsRequestInternal, ListPartnerProspectsResponse, ListPartnersConnectedToPageRequest, ListPartnersConnectedToPageResponse, ListPrioritiesForPartnerRequest, ListPrioritiesForPartnerResponse, ListPrioritiesForProspectRequest, ListPrioritiesForProspectResponse, MarketingAutomationApiService, MarketingFormsApiService, Metrics, Money, MultiSortingOptions, OnboardingStrategiesApiService, Opportunity, PagedRequestOptions, PagedResponseMetadata, PaidProductsRange, PartnerApiService, PartnerFacebookLeadAdsConnectionStatusRequest, PartnerFacebookLeadAdsConnectionStatusResponse, PartnerProspect, PaymentInfo, Person, PersonInformation, PersonName, Priority, ProspectApiService, PutAffiliatePaymentAmountsRequest, PutAffiliatePaymentAmountsResponse, PutAnalyticsPresetViewResponse, ReIgniteOldAccountsRequest, RemoveGoalFromProspectRequest, RemovePriorityFromProspectRequest, ReplaceEarlyWinForProspectRequest, ReplaceGoalForProspectRequest, ReplaceLeadQualificationSettingsRequest, ReplacePrioritiesForProspectRequest, SetPriorityRequest, SignUpDataCollectionApiService, SocialNetworkInformation, SortDirection, SortingOptions, Status, StatusType, SubscriptionChangeFilter, SubscriptionTier, TermsOfService, Tracker, UTMAttributes, UpdateAffiliateStatusRequest, UpdateAffiliateStatusResponse, UpdateAutomationRequest, UpdateAutomationResponse, UpdateDuplicateCriteriaRequest, UpdateLeadAdsAutomationStatusRequest, UpdateLeadAdsFormConnectionSettingsRequest, UpsertGoalsForPartnerRequest, UpsertPrioritiesForPartnerRequest, UtmFilters, WebsiteFilter };
